<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="z-index: 99;position: relative;">


      <!-- Loading null Page -->
      <CRow class="justify-content-center" v-if="register.stage == -1  && payment.step == 1">
        <CCol md="3">
          <CCardGroup>
            <CCard>
              <CCardBody style="padding-top: 35px;" class="verify_stage">
                <div style="display: inline-block;margin-left: 16px;vertical-align: 6px;">
                  <CSpinner size="5xl" />
                </div>
                <div style="display: inline-block;">
                  در حال پردازش فرآیند ثبت نام ... 
                  <br>
                  <span v-if="payment.step != 2">
                    لطفا صبور باشید 
                  </span>
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>


      <!-- Payment Go To bank -->
      <CRow class="justify-content-center" v-if="register.stage != 0 && payment.step == 2">
        <CCol md="6">
          <CCardGroup>
            <CCard
              color="primary"
              text-color="white"
              class="text-center d-md-down-none"
              id="payment_lottie"
              body-wrapper
            >
            <div>
              <lottie-player class="verify_stage" src="img/bank.json" :options="animation.bank"/>
              </div>
            </CCard>
            <CCard class="p-4">
              <CCardBody style="padding-top: 35px;" class="verify_stage">
                <div style="display: inline-block;margin-left: 16px;vertical-align: 6px;">
                  <CSpinner size="5xl" />
                </div>
                <div style="display: inline-block;">
                  در حال انتقال به درگاه بانکی ... 
                  <br>
                  لطفا صبور باشید
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
      
      
      <!-- Payment Result if status 1 -->
      <CRow class="justify-content-center" v-if="register.stage != 0 && payment.step == 3 && payment.status == 1">
        <CCol md="6">
          <CCardGroup>
            <CCard
              color="primary"
              text-color="white"
              class="text-center d-md-down-none"
              id="payment_lottie"
              body-wrapper
            >
            <div>
              <lottie-player class="verify_stage" src="img/done.json" :options="animation.done" loop="false"/>
              </div>
            </CCard>
            <CCard class="p-4">
              <CCardBody style="padding-top: 0px;" class="verify_stage">
                <div style="display: inline-block;">
                  مشترک گرامی<br>از خرید شما متشکریم و خرسندیم که در کنار ما هستید.<br>کارشناسان واحد استقرار حداکثر طی <b>۴۸‌ساعت‌کاری</b> آینده با شما ارتباط خواهند گرفت.
                </div>
                <div class="payed_tr_info">
                    اطلاعات تراکنش 
                  <table class="payed_tr_info">
                    <tr>
                      <td>شماره فاکتور</td>
                      <td>{{meta.id}}</td>
                    </tr>
                    <tr>
                      <td>شماره تراکنش</td>
                      <td>{{meta.payment.transaction_id}}</td>
                    </tr>
                    <tr>
                      <td>موبایل پاسخگو</td>
                      <td>{{register.user.mobile}}</td>
                    </tr>
                  </table>
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>

      </CRow>

      
      <!-- Payment Result if status 0 -->
      <CRow class="justify-content-center" v-if="register.stage != 0 && payment.step == 3 && payment.status == 0">
        <CCol md="6">
          <CCardGroup>
            <CCard
              color="primary"
              text-color="white"
              class="text-center d-md-down-none"
              id="payment_lottie"
              body-wrapper
            >
            <div style="padding-top: 33px;transform: scale(1.5);">
              <lottie-player class="verify_stage" src="img/failed.json" :options="animation.failed" loop="false" />
              </div>
            </CCard>
            <CCard class="p-4">
              <CCardBody style="padding-top: 0px;" class="verify_stage">
                <div style="display: inline-block;">
                  <h2 style="text-align: center;font-size: 19px;color: #e11c1c;">پرداخت ناموفق</h2>
کد خطا : {{meta.payment.errorCode}}
<br>
توضیح خطا : {{meta.payment.errorMessage}}
<br>
<b>توجه : </b>
در صورت کسر مبلغ از حساب شما، مبلغ کسر شده، حداکثر تا 72 ساعت به حساب فرد باز می گردد.
                </div>
                <div style="text-align: center;margin-top: 13px;margin-bottom: -12px;">
                <CButton
                  @click="register.stage = 6;payment.step = 1"
                  type="button"
                  class="reg_type_btn btn btn-success"
                >
                  برگشت و پرداخت مجدد
                </CButton>
                </div>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>


      <!-- Login Aria -->
      <CRow class="justify-content-center" v-if="register.stage == 0">
        <CCol md="6">
          <CCardGroup>
            <CCard
              color="primary"
              text-color="white"
              class="text-center d-md-down-none"
              id="hamkaran_brand_verify"
              body-wrapper
            >
              <lottie-player
                    src="img/welcome.json"
                    :options="animation.welcome"
                  />
            </CCard>
            <CCard class="p-4">
              <CCardBody class="verify_stage">
                <CForm v-if="verify_step === 1" v-on:submit.prevent="verify()">
                  <h1>ثبت نام تلفن ابری</h1>
                  <p class="text-muted">به فرآیند ثبت نام تلفن ابری خوش آمدید.</p>

                  <CAlert v-if="state.error" color="warning" closeButton>
                    شماره موبایل صحیح نیست
                  </CAlert>
                  <CAlert v-if="state.sessionEnded" color="warning" closeButton>
                    نشست منقضی شده است.
                  </CAlert>
                  <CInput
                    placeholder="شماره موبایل"
                    v-model="verify_mobile"
                    type="text"
                    autofocus 
                    v-on:keyup.enter="verify()"
                  >
                    <template #prepend-content>
                      <i class="fa-solid fa-mobile-screen-button" style="width: 14px;"></i>
                    </template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-right">
                      <!-- <CButton color="link" class="px-0" @click="register.stage = 1">
                        برگشت به مرحله قبل
                      </CButton> -->
                    </CCol>
                    <CCol col="12" class="text-left">
                      <CButton @click="verify" color="primary" >
                        تایید و ادامه
                      </CButton>
                    </CCol>
                  </CRow>
                  <CElementCover v-if="state.formLoading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CForm>


                <CForm v-if="verify_step === 2" class="step1-resetpass" v-on:submit.prevent="verify()">
                  <div
                    class="d-lg-none text-center"
                    id="hamkaran_brand_mob"
                  ></div>
                  <h1>
                    اعتبار سنجی هویت
                  </h1>
                  <p class="text-muted">
                    کد ارسال شده به شماره {{ verify_mobile }} را وارد نماید.
                  </p>
                  <CAlert v-if="state.error" color="warning" closeButton>
                    کد ارسال شده صحیح نیست یا منقضی شده است.
                  </CAlert>
                  <CAlert v-if="state.errorotp" color="warning" closeButton>
                    خطای داخلی: کد ارسال نشد.
                  </CAlert>
                  <CAlert v-if="state.successotp && verify_timerCount != 0" color="success" closeButton>
                    کد جدید با موفقعیت ارسال شد
                  </CAlert>
                  <CInput
                    style="margin-bottom: 0;"
                    v-model="verify_code"
                    v-on:keyup="(verify_code.length == 5)?verify():''"
                    name="verify_code"
                    autofocus 
                    placeholder="کد پیامک شده"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-dialpad" />
                    </template>
                  </CInput>

                  <span class="timer" v-if="verify_timerCount != 0">
                    مانده تا ارسال کد جدید {{ verify_timerCount }}
                  </span>
                  <CButton
                    style="margin: 6px auto;display: block;font-size: 12px;opacity: 0.7;"
                    color="link"
                    class="px-4"
                    v-if="verify_timerCount == 0"
                    @click="sendotp()"
                  >
                    ارسال کد جدید
                  </CButton>

                  <CRow>
                    <CCol col="4" class="text-right">
                      <CButton color="link" class="px-0" @click="verify_step = 1">
                        برگشت
                      </CButton>
                    </CCol>
                    <CCol col="8" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        @click="verify()"
                      >
                        اعتبار سنجی
                      </CButton>
                    </CCol>
                  </CRow>
                  <CElementCover v-if="state.formLoading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CForm>

                
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>



      <!-- Register Stages Aria -->
      <CRow class="justify-content-center" v-if="register.stage != 0 && payment.step==1 && register.stage != -1" >


        <CCol md="8" >

          <div class="stage_count" >
            <div class="stages stage_1" :class="stage_count(1)" @click="goToStage(2)">
              <span  v-if="stage_count(1) == 'done'" class="fa-stack fa-1x" style="flex-shrink: 0;position: absolute;right: 8px;top: 8px;"><i class="far fa-circle fa-stack-2x"></i> <i class="fas fa-check fa-stack-1x"></i></span>
              <i v-if="stage_count(1) == 'select'" class="fa-regular fa-pen-to-square" style="flex-shrink: 0;position: absolute;right: 23px;top: 16px;"></i>
              اطلاعات پایه
            </div>
            <div class="stages stage_2" :class="stage_count(3)" @click="goToStage(3)">
              <span  v-if="stage_count(3) == 'done'" class="fa-stack fa-1x" style="flex-shrink: 0;position: absolute;right: 8px;top: 8px;"><i class="far fa-circle fa-stack-2x"></i> <i class="fas fa-check fa-stack-1x"></i></span>
              <i v-if="stage_count(3) == 'select'" class="fa-regular fa-pen-to-square" style="flex-shrink: 0;position: absolute;right: 23px;top: 16px;"></i>
              انتخاب طرح
            </div>
            <div class="stages stage_3" :class="stage_count(4)" @click="goToStage(4)">
              <span  v-if="stage_count(4) == 'done'" class="fa-stack fa-1x" style="flex-shrink: 0;position: absolute;right: 8px;top: 8px;"><i class="far fa-circle fa-stack-2x"></i> <i class="fas fa-check fa-stack-1x"></i></span>
              <i v-if="stage_count(4) == 'select'" class="fa-regular fa-pen-to-square" style="flex-shrink: 0;position: absolute;right: 23px;top: 16px;"></i>
              انتخاب خط
            </div>
            <div class="stages stage_4" :class="stage_count(5)" @click="goToStage(5)">
              <span  v-if="stage_count(5) == 'done'" class="fa-stack fa-1x" style="flex-shrink: 0;position: absolute;right: 8px;top: 8px;"><i class="far fa-circle fa-stack-2x"></i> <i class="fas fa-check fa-stack-1x"></i></span>
              <i v-if="stage_count(5) == 'select'" class="fa-regular fa-pen-to-square" style="flex-shrink: 0;position: absolute;right: 23px;top: 16px;"></i>
              قوانین و مقررات
            </div>
            <div class="stages stage_5" :class="stage_count(6)" @click="goToStage(6)">
              <span  v-if="stage_count(6) == 'done'" class="fa-stack fa-1x" style="flex-shrink: 0;position: absolute;right: 8px;top: 8px;"><i class="far fa-circle fa-stack-2x"></i> <i class="fas fa-check fa-stack-1x"></i></span>
              <i v-if="stage_count(6) == 'select'" class="fa-regular fa-pen-to-square" style="flex-shrink: 0;position: absolute;right: 23px;top: 16px;"></i>
              پیش فاکتور
            </div>
          </div>


          <!-- Discount wrapper -->
          <div class="discount_wrapper" v-if="register.stage != 2 && register.stage != 1 && register.stage != 0">
            <div class="click_h" v-if="state.discount_status != 'valid'">
                <i class="fa fa-percent"></i>
                 در صورتی که کد تخفیف دارد آن را اینجا وارد کنید 
                 <CInput
                    v-on:focusout="form_check('person','last_name')"
                    placeholder="code"
                    v-model="register.discouny_code"
                  />
                  <!--  v-model="register.user.person.last_name" -->
                  <CButton
                    @click="discount_check()"
                    type="button"
                    class="reg_type_btn btn btn-success"
                    :disabled="(register.discouny_code)?false:true"
                  >
                    اعمال کد تخفیف
                  </CButton>
                  <div v-if="state.discount_error" class="discount_error">
                    کد تخفیف وارد شده اشتباه است و یا شرایط استفاده از آن به پایان رسیده.
                  </div>
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
            </div>

            <div class="click_h valid" v-if="state.discount_status == 'valid'">
                  <i class="fa fa-percent"></i>
                  <div style="display: inherit;padding-right: 8px;padding-left: 10px;">
                  تخفیف {{discount.percent}} درصدی بر روی طرح اشتراک

                  <b>({{ register.discouny_code }})</b>
                  </div>

                  <CButton
                    @click="state.discount_status ='none';discount.discount_ceiling=0;discount.percent=0"
                    type="button"
                    class="reg_type_btn btn-danger"
                  >
                    حذف تخفیف
                  </CButton>
            </div>
          </div>


          <div class="main_reg">
            
            <!-- STAGE 1 -->
            <div class="stage_1" v-if="register.stage == 1">
              <div class="top_dec_reg">
                <b class="red">* </b>لطفا نوع ثبت نام خط خود را انتخاب کنید.
              </div>
              <CRow>
                <CCol md="6">
                  <div class="select_reg_type">
                    <lottie-player
                      src="img/real.json"
                      :options="animation.real"
                    />
                    <div class="reg_type_t">
                     ثبت‌نام حقیقی
                    </div>
                    <div class="type_dec">
                      <b>ویژگی‌ها</b>
                      <br />
                      <b>-</b> فقط خرید خطوط ۲ کانالِ میسر است.
                      <br />
                      <b>-</b> حساسیت در حجم بالای تماس‌های خروجی<br /><br />
                      <b>مدارک مورد نیاز</b>
                      <br />
                      <b>-</b> نشانی  محل سکونت 
                      <br />
                      <b>-</b> شماره موبایل به نام صاحب خط
                      <br />
                      <b>-</b> تصویر کارت ملی و شناسنامه
                      <br />
                      <b>-</b> ایمیل در دسترس
                      <br />
                      <b>-</b> شماره تلفن ثابت
                    </div>
                    <button
                      @click="
                        numbers.channel = 2;
                        register.stage = 2;
                        register.user.type = 1;
                        loading=false;
                      "
                      type="button"
                      class="reg_type_btn btn btn-info"
                    >
                    ثبت‌نام حقیقی
                    </button>
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="select_reg_type">
                    <lottie-player
                      src="img/legal.json"
                      :options="animation.legal"
                    />
                    <div class="reg_type_t">
                      ثبت‌نام حقوقی
                    </div>
                    <div class="type_dec">
                      <b>ویژگی‌ها</b>
                      <br />
                      <b>-</b> خرید خطوط ۲ کانالِ و یا ۱۰ کانال به بالا میسر است.
                      <br />
                      <b>-</b> عدم حساسیت در حجم بالای تماس‌های خروجی<br /><br />
                      <b>مدارک مورد نیاز</b>
                      <br />
                      <b>-</b> شرکت ثبت شده همراه با شناسه ملی و شماره ثبت
                      <br />
                      <b>-</b> نشانی محل قانونی شرکت
                      <br />
                      <b>-</b> شماره موبایل به نام یکی از صاحبان امضاء شرکت
                      <br />
                      <b>-</b> تصویر کارت ملی و شناسنامه صاحبان حق امضاء
                      <br />
                      <b>-</b> ایمیل در دسترس
                      <br />
                      <b>-</b> شماره تلفن ثابت
                    </div>
                    <button
                      @click="
                        register.stage = 2;
                        register.user.type = 2;
                        loading=false;
                      "
                      type="button"
                      class="reg_type_btn btn btn-info"
                    >
                    ثبت‌نام حقوقی
                    </button>
                  </div>
                </CCol>
              </CRow>
            </div>

            <!-- STAGE 2 type 2 -->
            <div class="stage_1_1" v-if="register.stage == 2 && register.user.type == 2">
              <CRow>

                <CCard v-if="register.user.company.stage == 1">
                  <CCardHeader class="hamkaran_header register_header">
                    ورود اطلاعات شرکت
                    <span>
                      ثبت نام حقوقی
                    </span>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol md="12">
                        <CAlert v-for="item in form_errors.company"  v-if="item.status"  color="warning" closeButton>
                          <b>{{item.name}} : </b>
                          {{item.message}}
                        </CAlert>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('company','name')"
                          :class="{'error':form_errors.company.name.status}"
                          label="نام کامل شرکت"
                          placeholder="مثال : طرح و توسعه پردازش همکاران"
                          v-model="register.user.company.name"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('company','company_national_code')"
                          :class="{'error':form_errors.company.company_national_code.status}"
                          label="شناسه ملی شرکت"
                          placeholder="مثال: 14006878671"
                          v-model="register.user.company.company_national_code"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('company','registration_number')"
                          :class="{'error':form_errors.company.registration_number.status}"
                          label="شماره ثبت"
                          placeholder="مثال : 511764"
                          v-model="register.user.company.registration_number"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('company','phone')"
                          :class="{'error':form_errors.company.phone.status}"
                          label="شماره تلفن ثابت"
                          placeholder="تلفن شرکت همراه با کد شهر"
                          v-model="register.user.company.phone"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="ایمیل شرکت"
                          placeholder="ایمیل شرکت"
                          v-model="register.user.company.email"
                          v-on:focusout="form_check('company','email')"
                          :class="{'error':form_errors.company.email.status}"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="وب سایت"
                          placeholder="وب‌سایت"
                          v-model="register.user.company.site"
                          v-on:focusout="form_check('company','site')"
                          :class="{'error':form_errors.company.site.status}"
                        />
                      </CCol>
                      <CCol md="2">
                        <div role="group" class="form-group" 
                          :class="{'error':form_errors.company.provinces.status}">
                          <label  class="">استان</label>
                          <select class="form-control" v-model="register.user.company.provinces" v-on:focusout="form_check('company','provinces')">
                            <option value="" selected="selected" hidden="hidden" > استان  </option>
                            <option  v-for="(province, index) in provinces" :value="index">
                              {{province.text}}
                            </option>
                          </select>
                        </div>
                      </CCol>
                      <CCol md="7">
                        <CInput
                          label="آدرس قانونی"
                          placeholder="آدرس قانونی"
                          v-model="register.user.company.address"
                          v-on:focusout="form_check('company','address')"
                          :class="{'error':form_errors.company.address.status}"
                        />
                      </CCol>
                      <CCol md="3">
                        <CInput
                          label="کد پستی"
                          placeholder="کد پستی"
                          v-model="register.user.company.postal_code"
                          v-on:focusout="form_check('company','postal_code')"
                          :class="{'error':form_errors.company.postal_code.status}"
                        />
                      </CCol>
                    </CRow>

                    <CRow>
                      <CCol md="6" :class="{'error':form_errors.company.registered_advertisement.status}">
                        <b :class="{'error':form_errors.company.registered_advertisement.status}" style="padding-bottom: 6px;display: block;">
                          آگهی ثبتی 
                        </b>
                        <VueFileAgent
                          ref="RDvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'RDvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.company.registered_advertisement"
                        >
                        </VueFileAgent>
                      </CCol>
                      <CCol md="6" :class="{'error':form_errors.company.articles_of_association.status}" >
                        <b :class="{'error':form_errors.company.articles_of_association.status}" style="padding-bottom: 6px;display: block;">
                          اساسنامه شرکت
                        </b>
                        <VueFileAgent
                          ref="AOAvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'AOAvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.company.articles_of_association"
                        >
                        </VueFileAgent>
                      </CCol>
                      <CCol md="12">
                        <br>
                        <b style="padding-bottom: 6px;display: block;">
                          آخرین تغییرات  
                          <span style="font-size: 12px;font-weight: normal;">
                            (در صورتی که در تغییرات امضاء داران شرکت تغییر کرده است، آگهی روزنامه رسمی آخرین تغییرات شرکت را اینجا آپلود نمایید.)
                          </span>
                        </b>
                        <VueFileAgent
                          ref="LCvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'LCvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.company.last_changes"
                        >
                        </VueFileAgent>
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        <CButton
                          @click="register.stage = 1;register.user.type = 0;"
                          color="link"
                        >
                          برگشت و تغییر نوع ثبت نام
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="save()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          ثبت و ادامه
                        </CButton>

                      </CCol>
                    </CRow>
                  </CCardFooter>
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>

                <CCard  v-if="register.user.company.stage == 2">
                  <CCardHeader class="hamkaran_header register_header">
                     اطلاعات نماینده قانونی شرکت
                    <span>
                     اطلاعات هویتی 
                    </span>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol md="12">
                        <CAlert v-for="item in form_errors.person"  v-if="item.status"  color="warning" closeButton>
                          <b>{{item.name }} : </b>
                          {{item.message}}
                        </CAlert>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('person','first_name')"
                          :class="{'error':form_errors.person.first_name.status}"
                          label="نام به فارسی"
                          placeholder="نام  به فارسی"
                          v-model="register.user.person.first_name"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('person','last_name')"
                          :class="{'error':form_errors.person.last_name.status}"
                          label="نام خانوادگی به فارسی"
                          placeholder="نام خانوادگی به فارسی"
                          v-model="register.user.person.last_name"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('person','national_code')"
                          :class="{'error':form_errors.person.national_code.status}"
                          label="کد ملی"
                          placeholder="کد ملی"
                          v-model="register.user.person.national_code"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="شماره موبایل"
                          placeholder="شماره موبایل"
                          disabled="true"
                          v-model="register.user.person.mobile"
                          v-on:focusout="form_check('person','mobile')"
                          :class="{'error':form_errors.person.mobile.status}"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="ایمیل"
                          placeholder="ایمیل"
                          v-model="register.user.person.email"
                          v-on:focusout="form_check('person','email')"
                          :class="{'error':form_errors.person.email.status}"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="سمت در شرکت"
                          placeholder="مثال : رییس هیئت مدیره"
                          v-model="register.user.person.position"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="6" :class="{'error':form_errors.person.image_of_national_card.status}">
                        <b :class="{'error':form_errors.person.image_of_national_card.status}" style="padding-bottom: 6px;display: block;">
                        بارگذاری کارت ملی
                        </b>
                        <VueFileAgent
                          ref="ICvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'ICvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.person.image_of_national_card"
                        >
                        </VueFileAgent>
                      </CCol>
                      <CCol md="6" :class="{'error':form_errors.person.image_of_birth_certificate.status}">
                        <b :class="{'error':form_errors.person.image_of_birth_certificate.status}" style="padding-bottom: 6px;display: block;">
                          بارگذاری شناسنامه 
                        </b>
                        <VueFileAgent
                          ref="CBCvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'CBCvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.person.image_of_birth_certificate"
                        >
                        </VueFileAgent>
                      </CCol>
                    </CRow>
                  </CCardBody>
                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        <CButton
                          @click="register.user.company.stage = 1"
                          color="link"
                        >
                          برگشت و تغییر اطلاعات شرکت
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="save()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          ثبت و ادامه
                        </CButton>

                      </CCol>
                    </CRow>
                  </CCardFooter>
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>
              </CRow>
            </div>    
            
            

            <!-- STAGE 2 type 1 -->
            <div class="stage_1_1" v-if="register.stage == 2 && register.user.type == 1">

              <CRow>
                <CCard>
                  <CCardHeader class="hamkaran_header register_header">
                    ورود اطلاعات هویتی
                    <span>
                      ثبت نام حقیقی
                    </span>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol md="12">
                        <CAlert v-for="item in form_errors.person"  v-if="item.status"  color="warning" closeButton>
                          <b>{{item.name }} : </b>
                          {{item.message}}
                        </CAlert>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="3">
                        <CInput
                          v-on:focusout="form_check('person','first_name')"
                          :class="{'error':form_errors.person.first_name.status}"
                          label="نام به فارسی"
                          placeholder="نام  به فارسی"
                          v-model="register.user.person.first_name"
                        />
                      </CCol>
                      <CCol md="3">
                        <CInput
                          v-on:focusout="form_check('person','last_name')"
                          :class="{'error':form_errors.person.last_name.status}"
                          label="نام خانوادگی به فارسی"
                          placeholder="نام خانوادگی به فارسی"
                          v-model="register.user.person.last_name"
                        />
                      </CCol>
                      <CCol md="3">
                        <CInput
                          v-on:focusout="form_check('person','national_code')"
                          :class="{'error':form_errors.person.national_code.status}"
                          label="کد ملی"
                          placeholder="کد ملی"
                          v-model="register.user.person.national_code"
                        />
                      </CCol>
                      <CCol md="3">
                        <CInput
                          v-on:focusout="form_check('person','brand')"
                          :class="{'error':form_errors.person.brand.status}"
                          label="نام کسب و کار"
                          placeholder="نام کسب و کار"
                          v-model="register.user.person.brand"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          v-on:focusout="form_check('person','phone')"
                          :class="{'error':form_errors.person.phone.status}"
                          label="شماره تلفن ثابت"
                          placeholder="شماره تلفن ثابت با کد شهر"
                          v-model="register.user.person.phone"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="شماره موبایل"
                          placeholder="شماره موبایل"
                          disabled="true"
                          v-model="register.user.person.mobile"
                          v-on:focusout="form_check('person','mobile')"
                          :class="{'error':form_errors.person.mobile.status}"
                        />
                      </CCol>
                      <CCol md="4">
                        <CInput
                          label="ایمیل"
                          placeholder="ایمیل"
                          v-model="register.user.person.email"
                          v-on:focusout="form_check('person','email')"
                          :class="{'error':form_errors.person.email.status}"
                        />
                      </CCol>
                      <CCol md="2">
                        <div role="group" class="form-group" 
                          :class="{'error':form_errors.person.provinces.status}">
                          <label  class="">استان</label>
                          <select class="form-control" v-model="register.user.person.provinces" v-on:focusout="form_check('person','provinces')">
                            <option value="" selected="selected" hidden="hidden" > استان  </option>
                            <option  v-for="(province, index) in provinces" :value="index">
                              {{province.text}}
                            </option>
                          </select>
                        </div>
                      </CCol>
                      <CCol md="7">
                        <CInput
                          label="آدرس محل سکونت"
                          placeholder="آدرس محل سکونت"
                          v-model="register.user.person.address"
                          v-on:focusout="form_check('person','address')"
                          :class="{'error':form_errors.person.address.status}"
                        />
                      </CCol>
                      <CCol md="3">
                        <CInput
                          label="کد پستی"
                          placeholder="کد پستی"
                          v-model="register.user.person.postal_code"
                          v-on:focusout="form_check('person','postal_code')"
                          :class="{'error':form_errors.person.postal_code.status}"
                        />
                      </CCol>
                      <CCol md="6" :class="{'error':form_errors.person.image_of_national_card.status}">
                        <b :class="{'error':form_errors.person.image_of_national_card.status}" style="padding-bottom: 6px;display: block;">بارگذاری کارت ملی</b>
                        <VueFileAgent
                          ref="NCvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'NCvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.person.image_of_national_card"
                        >
                        </VueFileAgent>
                      </CCol>
                      <CCol md="6" :class="{'error':form_errors.person.image_of_birth_certificate.status}">
                        <b :class="{'error':form_errors.person.image_of_birth_certificate.status}" style="padding-bottom: 6px;display: block;">بارگذاری شناسنامه </b>
                        <VueFileAgent
                          ref="BCvueFileAgent"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :linkable="true"
                          :accept="'image/*,.zip,.pdf'"
                          :maxSize="'25MB'"
                          :maxFiles="3"
                          :helpText="$t('ticket.attachment_helpText')"
                          :errorText="{
                            type: $t('ticket.attachment_error.type'),
                            size: $t('ticket.attachment_error.size'),
                          }"
                          @upload="onUpload($event)"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event,'BCvueFileAgent')"
                          @delete="fileDeleted($event)"
                          v-model="register.user.person.image_of_birth_certificate"
                        >
                        </VueFileAgent>
                      </CCol>
                    </CRow>
                  </CCardBody>

                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        
                        <CButton
                          @click="register.stage = 1;register.user.type = 0;"
                          color="link"
                        >
                          برگشت و تغییر نوع ثبت نام
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="save()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          ثبت و ادامه
                        </CButton>

                      </CCol>
                    </CRow>
                  </CCardFooter>
                      
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>
              </CRow>
            </div>

            
            <!-- STAGE 3 -->
            <div class="stage_3" v-if="register.stage == 3">
              <CRow>
                <CCard>
                  <CCardHeader class="hamkaran_header register_header">
                    انتخاب طرح اشتراک
                    <span>
                      طرح اشتراک خود را انتخاب کنید
                    </span>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol md="12">
                        <CAlert v-if="state.notSelectPlan" color="warning" closeButton>
                          برای ادامه باید طرح اشتراک خود را انتخاب نمایید.
                        </CAlert>
                      </CCol>
                      <CCol md="4" v-for="subscription in subscriptions" v-if="register.plan == subscription.id || register.plan == '' ">
                        <div class="subscription_plan" :class="(subscription.id == register.plan)?'selected':''">
                          <div v-if="subscription.id == register.plan" class="ribbon ribbon-top-left"><span>
                            <i class="fa-solid fa-check"></i>
                            انتخاب شد
                          </span></div>
                          <div class="title">
                            {{subscription.name}}
                          </div>
                          <div class="namad">
                            <img v-if="subscription.id == 1" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-پایه-تلفن-ابری-همکاران-1-p8gvc7c8y092sd9g5df1dktfuf961bcgd8ysv9scc4.png.webp" title="طرح پایه تلفن ابری همکاران" alt="طرح پایه تلفن ابری همکاران">
                            <img v-if="subscription.id == 2" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-دو-تلفن-ابری-همکاران-p8gwa91shyuzbvt1c38joziigvfsumifprnyo3ayyc.png.webp" title="طرح دو تلفن ابری همکاران" alt="طرح دو تلفن ابری همکاران">
                            <img v-if="subscription.id == 3" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-سه-تلفن-ابری-همکاران-p8gwsy28fcga8ong665fa9ojsralxwq8yarma7l378.png.webp" title="طرح سه تلفن ابری همکاران" alt="طرح سه تلفن ابری همکاران">
                            <img v-if="subscription.id == 4" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-چهار-تلفن-ابری-همکاران-p8gwxr0jcv11kxo848ws121d3nm5a7suy2syl4gnec.png.webp" title="طرح چهار تلفن ابری همکاران" alt="طرح سه تلفن ابری همکاران">
                          </div>
                          <div class="price" v-if="discount.percent == 0">
                            {{Number(subscription.base_price/10).toLocaleString()}} تومان
                          </div>
                          <div class="price discount" v-if="discount.percent != 0">
                            {{Number(subscription.base_price/10).toLocaleString()}} تومان
                          </div>
                          <div class="price" v-if="discount.percent != 0">
                            {{Number((subscription.base_price-(subscription.base_price*(discount.percent/100)))/10).toLocaleString()}} تومان
                          </div>
                          <div class="period">
                            اشتراک سالیانه
                          </div>
                          <div class="features">
                            <ul class="features">
                              <li>
                                <i class="fa-solid fa-check"></i>
                                {{subscription.description}}
                              </li>
                              <li >
                                <i class="fa-solid fa-check"></i>
                                تمامی  
                                <b v-c-tooltip='{content: "<div class=features_tootip_dec>امکانات پایه شامل تمامی امکانات استاندارد یک مرکز تماس حرفه‌ای شامل موارد زیر است.</div><table  class=features_tootip><tr><td>ضبط مکالمات</td><td>صف تماس</td></tr><tr><td>پنل مدیریت و گزارشات</td><td>صندوق صوتی</td><tr><td>کلاینت اختصاصی همکاران</td><td>CID Lockup</td></tr><tr><td>تلفن گویا </td><td>تماس ورودی و خروجی</td></tr><tr><td colspan=2> قابلیت استفاده در تلفن سخت افزاری</td></tr></table>",html: true}'>
                                  امکانات پایه
                                </b>
                              </li>
                              <li>
                                <i class="fa-solid fa-check"></i>
                                ماژول دیدار
                              </li>
                              <li>
                                <i class="fa-solid " :class="(subscription.id == 1)?'fa-xmark':'fa-check'"></i>
                                وب هوک
                              </li>
                              <li>
                                <i class="fa-solid " :class="(subscription.id == 1 || subscription.id == 2)?'fa-xmark':'fa-check'"></i>
                                وب سرویس
                              </li>
                            </ul>
                          </div>
                          <CButton
                            v-if="register.plan!=subscription.id"
                            style="margin: 6px auto;display: block;font-size: 12px;opacity: 0.7;"
                            color="success"
                            @click="register.plan=subscription.id;scrollToBottom();register.add_ons=[]"
                          >
                            انتخاب
                          </CButton>
                          <CButton
                            v-if="register.plan==subscription.id"
                            style="margin: 6px auto;display: block;font-size: 12px;opacity: 0.7;"
                            color="danger"
                            @click="register.plan=0;register.add_ons=[]"
                          >
                            حذف
                          </CButton>
                        </div>
                      </CCol>
                      
                      <CCol md="8" v-if="register.plan == '' ">
                        <div class="subscription_plan no_hover" v-if="subscriptions.length > 0">
                          <div class="title">
                            طرح اختصاصی
                          </div>
                          <div class="namad">      
                            <img src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-پنج-تلفن-ابری-همکاران-p8gwyhc0o812m0lzukabyve9qg0f9qpcdp2k0vdmk4.png.webp" title="طرح پنج تلفن ابری همکاران" alt="طرح پنج تلفن ابری همکاران">
                          </div>
                          <div class="period">
                            اشتراک سالیانه
                          </div>
                          <div class="dec">
                            در صورتی که تعداد داخلی های مورد نیاز شما بیش از ۳۲ عدد داخلی می‌باشد، جهت دریافت طرح اختصاصی خود با کارشناسان مشاوره قبل از فروش ما تماس حاصل فرمایید.
                          </div>
                          <div class="cal_me">
                            <table >
                              <tr>
                                <td>
                                  ایمیل
                                </td>
                                <td>
                                  <a href="mailto:info@hamkaran.cloud">info@hamkaran.cloud</a>
                                  
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  شماره تماس
                                </td>
                                <td>
                                <a href="tel:+982191303513">02191303513</a>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  ارتباط طریق واتساپ
                                </td>
                                <td>
                                  <a href="http://" target="_blank" rel="noopener noreferrer">کیک کنید</a>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  چت آنلاین
                                </td>
                                <td>
                                  <a href="http://hamkaran.cloud/chat" target="_blank" rel="noopener noreferrer">کیک کنید</a>
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCardBody>

                  <CCardHeader class="hamkaran_header register_header" v-if="register.plan > 0 ">
                    انتخاب افزودنی ها
                    <span>
                      افزودنی های طرح اشتراک خود را انتخاب نمایید.
                    </span>
                  </CCardHeader>
                  <CCardBody v-if="register.plan > 0 ">
                    <CRow>
                      <CCol md="4" v-for="Addon in Addons" v-if="(Addon.id == 8 && register.plan ==1) || (Addon.id == 8 && register.plan ==2) || (Addon.id == 10 && register.plan == 1) || (Addon.id == 12)">
                        <div class="subscription_plan" >
                          <div v-if="addonIsAdded(Addon.id)" class="ribbon ribbon-top-left"><span>
                            <i class="fa-solid fa-check"></i>
                            انتخاب شد
                          </span></div>
                          <div class="help" v-if="Addon.id == 12" v-c-tooltip='{content: Addon.vhelp,html: true}'>
                              <i class="fa-solid fa-question"></i>
                          </div>
                          <div class="title">
                            {{Addon.name}}
                          </div>
                          <div class="namad">
                            <img v-if="Addon.id == 8" src="/img/webservice.png" style="height: 50px;">
                            <img v-if="Addon.id == 10" src="/img/webhookreg.png" style="height: 50px;">
                            <img v-if="Addon.id == 12" src="/img/call-center.png" style="height: 50px;">
                          </div>
                          <div class="price" v-if="discount.percent == 0">
                            {{Number(Addon.base_price/10).toLocaleString()}} تومان
                          </div>
                          <div class="price discount" v-if="discount.percent != 0">
                            {{Number(Addon.base_price/10).toLocaleString()}} تومان
                          </div>
                          <div class="price" v-if="discount.percent != 0">
                            {{Number((Addon.base_price-(Addon.base_price*(discount.percent/100)))/10).toLocaleString()}} تومان
                          </div>
                          
                          <div class="period">
                            اشتراک سالیانه
                          </div>
                          <div class="dec" v-if="Addon.id == 8 || Addon.id == 10">
                            راجع به {{Addon.name}} بیشتر بدانید. 
                            <br>
                            <a href="http://" target="_blank" rel="noopener noreferrer" style="line-height: 29px;">کسب اطلاعات بیشتر</a>
                            <br>
                          </div>
                          <div class="dec" v-if="Addon.id == 12">
                            
                            <CAlert v-if="state.addOnError" color="warning" closeButton>
                              تعداد خود را وارد کنید
                            </CAlert>
                            تعداد داخلی اضافه را وارد کنید 
                            <br>
                            تعداد : 
                            <input type="number" placeholder="تعداد داخلی " v-model="Addon.vcount" v-on:change="Addon.vadded=0;addToAddOn(Addon);">
                          </div>
                          <CButton
                            v-if="!addonIsAdded(Addon.id)"
                            style="margin: 6px auto;display: block;font-size: 12px;opacity: 0.7;"
                            color="success"
                            @click="Addon.vadded=1;addToAddOn(Addon)"
                          >
                            انتخاب
                          </CButton>
                          <CButton
                            v-if="addonIsAdded(Addon.id)"
                            style="margin: 6px auto;display: block;font-size: 12px;opacity: 0.7;"
                            color="danger"
                            @click="Addon.vadded=0;addToAddOn(Addon);"
                          >
                            حذف
                          </CButton>
                        </div>
                      </CCol>
                      

                    </CRow>
                  </CCardBody>
                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        
                        <CButton
                          @click="register.stage = 2;"
                          color="link"
                        >
                          برگشت به گام قبلی
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="save()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          ثبت و ادامه
                        </CButton>

                      </CCol>
                    </CRow>
                  </CCardFooter>
                      
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>
              </CRow>
            </div>

            <!-- STAGE 4 -->
            <div class="stage_4" v-if="register.stage == 4">
              <CRow>
                <CCard>
                  <CCardHeader class="hamkaran_header register_header">
                    انتخاب تامین کننده
                    <span>
                      لطفا اپراتور تامین کننده شماره ثابت را انتخاب کنید.
                    </span>
                  </CCardHeader>
                  <!-- Select Oprator -->
                  <CCardBody>
                    <CRow>
                      
                      <CCol md="12">
                        <CAlert color="light">
                          <b>توجه: </b>
                           مرکز تماس ابری با تمامی اینترنت‌ها کار می‌کند، اپراتورهای زیر فقط تأمین‌کننده خطوط شما هستند.
                        </CAlert>
                        <CAlert v-if="state.notNumberPlan" color="warning" closeButton>
                          برای ادامه باید حداقل یک شماره تلفن انتخاب نمایید.
                        </CAlert>
                      </CCol>     
                      <CCol md="4" v-for="operator in operators" v-if="numbers.oprator.id == 0 || operator.id == numbers.oprator.id">
                        <div class="subscription_plan operator" :class="(operator.active != 1)?'dactive':''" 
                        @click="numbers.type = 'none';(operator.active != 1)?'dactive':((operator.id == numbers.oprator.id)?numbers.oprator.id = 0:numbers.oprator.id = operator.id)">
                          <div v-if="operator.active != 1" class="dactive"><span>غیرفعال</span></div>
                          <div v-if="operator.id == numbers.oprator.id" class="ribbon ribbon-top-left">
                            <span>
                              <i class="fa-solid fa-check"></i>
                              انتخاب شد
                            </span>
                          </div>

                          <div class="help" v-c-tooltip='{content:operator.help,html: true}'>
                              <i class="fa-solid fa-question"></i>
                          </div>
                          <div class="right">  
                            <div class="title">
                              {{operator.name.en}}
                            </div>
                            <div class="namad">
                              <img :src="'/img/'+operator.logo" style="height: 33px;">
                            </div>
                          </div>
                          <div class="left">
                            <div class="price">
                              {{operator.name.fa}}
                            </div>
                            <div class="period">
                              <span style="display: block;font-size: 13px;">
                              پیش شماره
                              </span>
                              {{operator.prefix}}
                            </div>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCardBody>



                  <!-- Select Numbers -->
                  <CCardHeader class="hamkaran_header register_header" v-if="numbers.oprator.id != 0 ">
                    افزودن شماره
                    <span>
                      لطفا شماره تلفن ثابت را انتخاب نمایید.
                    </span>
                  </CCardHeader>
                  <CCardBody v-if="numbers.oprator.id != 0">
                    
                    <CRow>
                      <CCol md="12" v-if="numbers.type == 'none'">
                        <div class="subscription_plan" @click="numbers.type = 'transfer'">
                            شماره {{operators.filter(i => i.id == numbers.oprator.id)[0].name.fa}} دارم و میخواهم آن را به بستر تلفن ابری منتقل نمایم.
                        </div>
                        
                        <div class="subscription_plan" @click="numbers.type = 'new';getNumbers();">
                            میخواهم شماره جدید خریداری کنم.
                        </div>
                      </CCol>

                      <CCol md="12" v-if="numbers.type == 'transfer'" >
                        <div class="note" @click="numbers.type = 'new';getNumbers();" style="padding-bottom: 15px;cursor: pointer;" >
                            * جهت انتخاب و خرید شماره جدید اینجا کلیک کنید.
                        </div>
                        <div class="subscription_plan transfer" :style="'background-image: url(/img/'+operators.filter(i => i.id == numbers.oprator.id)[0].logo+');'">
                            
                            <CAlert v-if="state.transferNumber" color="warning" closeButton>
                              شماره انتخابی صحیح نیست
                            </CAlert>
                            <span>
                              لطفا اطلاعات شماره {{operators.filter(i => i.id == numbers.oprator.id)[0].name.fa}} خورد را در فرم زیر وارد نمایید.
                            </span>
                            <div class="number">
                              <CInput
                              :disabled="numbers.prefix_id == ''"
                                placeholder="چهار رقم انتهایی"
                                v-model="numbers.selected"
                                v-on:keyup.enter="addNumber('1',numbers.oprator.id,numbers.province_id,numbers.prefix_id,numbers.selected)"
                              />
                            </div>
                            
                            <div class="prefix">
                              <select class="form-control" v-model="numbers.prefix_id" :disabled="numbers.province_id == ''">
                                <option value="" selected="selected" hidden="hidden" >پیش شماره</option>
                                <option  v-for="(prefix, index) in numbers.prefixes" :value="prefix">
                                  {{prefix}}
                                </option>
                              </select>
                            </div>
                            <div class="provinces">
                              <select class="form-control" v-model="numbers.province_id" v-on:change="getprefixes()">
                                <option value="" selected="selected" hidden="hidden" > استان خود را انتخاب کنید </option>
                                <option  v-for="(province, index) in provinces" :value="index" v-if="operators[numbers.oprator.id-1].provinces.includes(parseInt(province.id))">
                                  {{province.text}}
                                </option>
                              </select>
                            </div>

                            <CButton
                            
                            style="margin: 6px auto;display: block;font-size: 12px;opacity: 0.7;"
                            color="success"
                            @click="addNumber('1',numbers.oprator.id,numbers.province_id,numbers.prefix_id,numbers.selected)"
                            >
                            افزودن شماره
                          </CButton>

                        </div>
                      </CCol>



                      <CCol md="12" v-if="numbers.type == 'new'" >
                        <div class="note" @click="numbers.type = 'transfer'" style="padding-bottom: 15px;cursor: pointer;" >
                            * جهت انتقال خط به بستر تلفن ابری اینجا کلیک کنید
                        </div>
                        <CRow v-if="this.register.user.type==2">
                          <CCol md="12" style="text-align: right;">
                            <span>
                               انتخاب تعداد کانال خط (ویژه مشترکین حقوقی) 
                            </span>
                            <!-- انتخاب کانال -->
                            <div class="channel_count" style="width:72px;display: inline-block;margin-right: 4px;">
                              <select class="form-control" v-model="numbers.channel">
                                <option value="2" selected="selected"  > 2  </option>
                                <option  v-for="(n,index) in 10" :value="n*10">
                                  {{ n*10 }} 
                                </option>
                              </select>
                            </div>
                            <div class="channel_help ">
                              <div class="help" v-c-tooltip='{content:numbers.channel_help,html: true}'>
                                  <i class="fa-solid fa-question"></i>
                                  کسب اطلاعات بیشتر
                              </div>
                            </div>
                          </CCol>
                        </CRow>
                        <br>
                        <CAlert v-if="state.transferNumber" color="warning" closeButton>
                          شماره انتخابی صحیح نیست
                        </CAlert>

                        <div class="search register" >
                          <CRow>
                            <CCol md="6">

                            <div class="provinces" style="width: 137px;display: inline-block;">
                              <select class="form-control" v-model="numbers.province_id" v-on:change="getNumbers(1)">
                                <option value="" selected="selected" hidden="hidden" > استان  </option>
                                <option  v-for="(province, index) in provinces" :value="index" v-if="operators[numbers.oprator.id-1].provinces.includes(parseInt(province.id))">
                                  {{province.text}}
                                </option>
                              </select>
                            </div>
                            
                            <CButton
                              style="margin-right: 10px;"
                              color="light"
                              @click="getNumbers(0)"
                              >
                              <i class="fa-solid fa-rotate"></i>
                               پیشنهاد شماره جدید
                            </CButton>

                            </CCol>

                            <CCol md="6" style="text-align: left;">
                              <div class="number" style="width: 117px;display: inline-block;">
                                <CInput
                                  :disabled="numbers.prefix_id == ''"
                                  placeholder="چهار رقم انتهایی"
                                  v-model="numbers.selected"
                                  v-on:keyup.enter="checkNumbers();"
                                />
                              </div>
                              <div class="prefix" style="width: 113px;display: inline-block;">
                                <select class="form-control" v-model="numbers.prefix_id" :disabled="numbers.province_id == ''">
                                  <option value="" selected="selected" hidden="hidden" >پیش شماره</option>
                                  <option  v-for="(prefix, index) in numbers.prefixes" :value="prefix">
                                    {{prefix}}
                                  </option>
                                </select>
                              </div>
                              <CButton
                                style="margin-right: 10px;"
                                color="light"
                                @click="checkNumbers();"
                                >
                                <i class="fa-solid fa-magnifying-glass"></i>
                                 جستجوی
                              </CButton>

                            </CCol>
                          </CRow>
                            

                            

                        </div>

                        <div class="search result" v-if="!loading">
                          <CRow>
                            <CCol md="12" v-if="numbers.list == ''" style="margin-top: 25px;margin-bottom: 25px;text-align: center;">
                              <CAlert color="warning">
                                شماره تلفن، در وضعیت آماده جهت واگذاری نمی‌باشد.
                              </CAlert>
                            </CCol>
                            <CCol md="3" class="mp2" v-for="number in numbers.list">
                              <div class="subscription_plan list" @click="addNumber('2',numbers.oprator.id,number.province_id,number.prefix,number.number,number)">
                                <div class="number" style="font-size: 19px;">
                                  <span>{{number.number.substring(0,3)}}</span>
                                  
                                  <span>{{number.number.substring(3,7)}} {{number.number.substring(7,11)}}</span>
                                </div>
                                <div class="type" :class="'oprator_'+numbers.oprator.id+' '+'num_'+number.type">
                                  {{$t(`register.${numbers.oprator.id}.number_type.${number.type}`)}} ({{numbers.channel}} کاناله)
                                </div>
                                <div class="price">
                                  {{Number(getNumberPrice(number)/10+((numbers.channel == 2)?'':numbers.channel*(getChannelPrice(number)/10))).toLocaleString()}} تومان
                                </div>
                              </div>

                            </CCol>
                          </CRow>
                        </div>

                        <div class="search result" v-if="loading">
                          <CRow>
                            <CCol md="3" class="mp2" v-for="index in 20" :key="index" >
                              <div class="subscription_plan list" >
                                <div class="number skeleton">
                                </div>
                                <div class="type skeleton" >
                                </div>
                                <div class="price skeleton">
                                </div>
                              </div>

                            </CCol>
                          </CRow>
                        </div>
                        
                      </CCol>
                    </CRow>
                  </CCardBody>


                  <!-- Show Selected number -->
                  <CCardHeader class="hamkaran_header register_header" v-if="register.numbers.length != 0 ">
                    شماره‌های انتخابی
                    <span>
                      شماره‌های انتخابی خود را اینجا مشاهده کنید.
                    </span>
                  </CCardHeader>
                  <CCardBody v-if="register.numbers.length != 0 ">
                    <CRow>
                      <CCol md="4" v-for="number in register.numbers" >
                        <div class="subscription_plan operator" >


                          <div class="close"
                           v-c-tooltip='{content:"حذف شماره",html: true}' 
                          @click="register.numbers = register.numbers.filter(i => i.number != number.number)">
                              <i class="fa-solid fa-xmark"></i>
                          </div>

                          <div class="right">  
                            <div class="title">
                              {{operators.filter(i => i.id == number.oprator_id)[0].name.en}}
                            </div>
                            <div class="namad">
                              <img :src="'/img/'+operators.filter(i => i.id == number.oprator_id)[0].logo" style="height: 33px;">
                            </div>
                          </div>
                          <div class="left">
                            <div class="number">
                              <span>{{number.number.substring(0,3)}}</span>
                              <span>{{number.number.substring(3,7)}} {{number.number.substring(7,11)}}</span>
                            </div>
                            <div class="period">
                              {{number.dec}}
                            </div>
                            <div class="price" v-if="number.price == 0" style="padding-bottom: 2px;">
                              رایگان
                            </div>
                            <div class="price" v-if="number.price != 0" style="padding-bottom: 2px;">
                              {{Number(getNumberPrice(number.obj)/10+((number.obj.channel == 2)?'':number.obj.channel*(getChannelPrice(number.obj)/10))).toLocaleString()}} تومان
                            </div>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCardBody>


                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        
                        <CButton
                          @click="register.stage = 3;"
                          color="link"
                        >
                          برگشت به گام قبلی
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="save()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          ثبت و ادامه
                        </CButton>

                      </CCol>
                    </CRow>
                  </CCardFooter>
                      
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>
              </CRow>
            </div>

            <!-- STAGE 5 -->
            <div class="stage5" v-if="register.stage == 5">

              <CRow>
                <CCard>
                  <CCardHeader class="hamkaran_header register_header">
                    قوانین و مقررات
                    <span>
                      قوانین و مقررارت استفاده از تلفن ابری همکاران
                    </span>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol md="12">
                        <div class="t_a_c_warper">
                          <div class="t_a_C" v-if="!terms.content">
                            <h1 class="skeleton" style="text-align: center;margin: 0px auto;width: 200px;height: 22px;margin-bottom: 10px;visibility: show !important;"></h1>
                            <p style="height: 20px;" v-for="index in 11" :key="index" class="skeleton"></p>
                          </div>
                          <div class="t_a_C" v-if="terms.content" >
                            <h1>{{terms.title.rendered}}</h1>
                            <div v-html="terms.content.rendered"></div>
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCardBody>

                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        <CButton
                          @click="register.stage = 4;"
                          color="link"
                        >
                          برگشت و تغییر  شماره
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="save()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          پذیرش قوانین و ادامه
                        </CButton>

                      </CCol>
                    </CRow>
                  </CCardFooter>
                      
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>
              </CRow>
            </div>

            <!-- STAGE 6 -->
            <div class="stage6" v-if="register.stage == 6">

              <CRow>
                <CCard>
                  <CCardHeader class="hamkaran_header register_header">
                    پیش‌ فاکتور
                    <span>
                    خدمات انتخابی تلفن ابری
                    </span>
                    <span title="پرینت پیش فاکتور" class="header_print_btn" onclick="printJS({printable: 'invoice', type: 'html', scanStyles: false,css: '/css/print.css'})">
                      <i  class="fa-solid fa-print"></i>
                      پرینت
                    </span>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol md="12" id="invoice">
                        <table  class="invoice_he">
                          <tr>
                            <td>
                              <img src="/img/ph_new.png" alt="">
                            </td>
                            <td>پیش فاکتور</td>
                            <td>
                              تاریخ : 
                              {{new Date(meta.updated_at) | moment('jYYYY/jM/jD')}}
                              <br>
                              شماره : 
                              {{meta.id}}
                              <br>
                              <img src="https://api.hamkaran.cloud/v1/barcode/1" alt="">
                            </td>
                          </tr>
                        </table>
                        <table class="invoice_t">
                          <tr>
                            <td rowspan="2" class="invoice_tvt1" >
                              <span class="invoice_tvt" style="right: -8px">فروشنده</span>
                            </td>
                            <td>نام: شرکت طرح و توسعه پردازش همکاران</td>
                            <td>شماره اقتصادی: 411663181731</td>
                            <td>شناسه ملی: 14006878671</td>
                            <td>تلفن : 02191301664</td>
                          </tr>
                          <tr>
                            <td colspan="3">نشانی: تهران، انتهای اتوبان شهید ستاری شمال، دانشگاه آزاد اسلامی واحد علوم و تحقیقات، ساختمان بام نوآوری تهران</td>
                            <td>کدپستی: 1477890006</td>
                          </tr>
                        </table>
                        <br>

                        <table class="invoice_t"  v-if="this.register.user.type==2">
                          <tr>
                            <td rowspan="2" class="invoice_tvt1" >
                              <span class="invoice_tvt" style="right: -8px">فروشنده</span>
                            </td>
                            <td>نام: {{this.register.user.company.name}}</td>
                            <td>شناسه ملی: {{this.register.user.company.company_national_code}}</td>
                            <td>شناسه ثبت: {{this.register.user.company.registration_number}}</td>
                            <td>تلفن : {{this.register.user.company.phone}}</td>
                          </tr>
                          <tr>
                            <td colspan="3">نشانی:  {{this.register.user.company.address}}</td>
                            <td>کدپستی: {{this.register.user.company.postal_code}}</td>
                          </tr>
                        </table>
                        <table class="invoice_t" v-if="this.register.user.type==1">
                          <tr>
                            <td rowspan="2" class="invoice_tvt1">
                              <span class="invoice_tvt" style="right: -1px">خریدار</span>
                            </td>
                            <td>
                             نام: {{register.user.person.first_name}} {{register.user.person.last_name}}
                            </td>
                            <td colspan="2">کد ملی: {{register.user.person.national_code}}</td>
                            <td>تلفن : {{register.user.person.phone}}</td>
                          </tr>
                          <tr>
                            <td colspan="3">نشانی: {{register.user.person.address}}</td>
                            <td>کدپستی: {{register.user.person.postal_code}}</td>
                          </tr>
                        </table>
                        <br>
                        <table class="invoice_t">
                          <thead>
                            <tr>
                              <td style="width: 30px;">ردیف</td>
                              <td>شرح خدمات</td>
                              <td style="width: 30px;">نوع</td>
                              <td>مبلغ</td>
                              <td v-if="discount.percent != 0">تخفیف</td>
                              <td>عوارض و مالیات</td>
                              <td>مبلغ نهایی</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>
                               طرح اشتراک {{plan[0].name}} 
                               <span style="display: block;">{{plan[0].description}}</span>
                              </td>
                              <td>سالیانه</td>
                              <td>
                                {{Number(plan[0].base_price/10).toLocaleString()}} تومان
                              </td>
                              <td  v-if="discount.percent == 0">{{Number((plan[0].base_price/10)*0.10 ).toLocaleString() }} تومان</td>
                              <td  v-if="discount.percent == 0">{{Number((plan[0].base_price/10)+((plan[0].base_price/10)*0.10)).toLocaleString()}} تومان</td>

                              
                              <td v-if="discount.percent != 0">
                                {{Number((plan[0].base_price*(discount.percent/100))/10).toLocaleString()}} تومان
                              </td>
                              <td  v-if="discount.percent != 0">{{Number(((plan[0].base_price/10)-((plan[0].base_price*(discount.percent/100))/10))*0.10 ).toLocaleString() }} تومان</td>
                              <td  v-if="discount.percent != 0">{{Number(((plan[0].base_price/10)-((plan[0].base_price*(discount.percent/100))/10))*1.09 ).toLocaleString()}} تومان</td>
                            </tr>

                            <tr  v-for="(rplan, index) in register.add_ons">
                              <td>{{index+2}}</td>
                              <td>
                                {{rplan.name}}
                                <span v-if="rplan.id == 12" style="display: block;">
                                  {{rplan.vcount}} عدد
                                </span>
                              </td>
                              <td>سالیانه</td>
                              <td v-if="rplan.id != 12">
                                 {{Number(rplan.base_price/10).toLocaleString()}} تومان
                              </td>
                              <td v-if="rplan.id != 12 && discount.percent == 0">{{Number((rplan.base_price/10)*0.10 ).toLocaleString() }} تومان</td>
                              <td v-if="rplan.id != 12 && discount.percent == 0">{{Number((rplan.base_price/10)+((rplan.base_price/10)*0.10)).toLocaleString()}} تومان</td>
                              <td v-if="rplan.id == 12">
                                 {{Number((rplan.base_price*rplan.vcount)/10).toLocaleString()}} تومان
                              </td>
                              <td v-if="rplan.id == 12  && discount.percent == 0">{{Number(((rplan.base_price*rplan.vcount)/10)*0.10 ).toLocaleString() }} تومان</td>
                              <td v-if="rplan.id == 12  && discount.percent == 0">{{Number(((rplan.base_price*rplan.vcount)/10)+(((rplan.base_price*rplan.vcount)/10)*0.10)).toLocaleString()}} تومان</td>


                              <td v-if="rplan.id != 12 && discount.percent != 0">
                                {{Number((rplan.base_price*(discount.percent/100))/10).toLocaleString()}} تومان
                              </td>
                              <td v-if="rplan.id != 12 && discount.percent != 0">
                                {{Number(((rplan.base_price-(rplan.base_price*(discount.percent/100)))/10)*0.10).toLocaleString() }} تومان
                              </td>
                              <td v-if="rplan.id != 12 && discount.percent != 0">
                                {{Number(((rplan.base_price-(rplan.base_price*(discount.percent/100)))/10)*1.09).toLocaleString() }} تومان
                              </td>


                              
                              <td v-if="rplan.id == 12 && discount.percent != 0">
                                {{Number(((rplan.base_price*rplan.vcount)*(discount.percent/100))/10).toLocaleString()}} تومان
                              </td>
                              <td v-if="rplan.id == 12 && discount.percent != 0">
                                {{Number((((rplan.base_price*rplan.vcount)-((rplan.base_price*rplan.vcount)*(discount.percent/100)))/10)*0.10).toLocaleString() }} تومان
                              </td>
                              <td v-if="rplan.id == 12 && discount.percent != 0">
                                {{Number((((rplan.base_price*rplan.vcount)-((rplan.base_price*rplan.vcount)*(discount.percent/100)))/10)*1.09).toLocaleString() }} تومان
                              </td>
                            </tr>

                            <tr>
                              <td>{{register.add_ons.length+2}}</td>
                              <td>
                                {{setup.name}}
                              </td>
                              <td>یکبار</td>
                              <td>
                                {{Number(setup.base_price/10).toLocaleString()}} تومان
                              </td>
                              <td v-if="discount.percent != 0">
                                -
                              </td>
                              <td>{{Number((setup.base_price/10)*0.10 ).toLocaleString() }} تومان</td>
                              <td>{{Number((setup.base_price/10)+((setup.base_price/10)*0.10)).toLocaleString()}} تومان</td>
                            </tr>

                            <tr  v-for="(number, index) in register.numbers">
                              <td>{{register.add_ons.length+3+index}}</td>
                              <td>
                                خط 
                                {{operators.filter(i => i.id == number.oprator_id)[0].name.fa}} {{number.number}} 
                                <br>
                                {{number.dec}}
                              </td>
                              <td>یکبار</td>
                              <td v-if="number.price != 0">
                                
                                {{Number((getNumberPrice(number.obj)+((number.obj.channel == 2)?'':number.obj.channel*(getChannelPrice(number.obj))))/10).toLocaleString()}}  تومان
                              </td>
                              <td v-if="discount.percent != 0 && number.price != 0 ">
                                -
                              </td>
                              <td v-if="number.price != 0">
                                {{Number((getNumberPrice(number.obj)+((number.obj.channel == 2)?'':number.obj.channel*(getChannelPrice(number.obj))))*0.009).toLocaleString()}}  تومان
                              </td>
                              <td v-if="number.price != 0">
                                {{Number((getNumberPrice(number.obj)+((number.obj.channel == 2)?'':number.obj.channel*(getChannelPrice(number.obj))))*0.109).toLocaleString()}}  تومان
                              </td>
                              <td v-if="number.price == 0">رایگان</td>
                              <td v-if="discount.percent != 0 && number.price == 0 ">
                                -
                              </td>
                              <td v-if="number.price == 0">رایگان</td>
                              <td v-if="number.price == 0">رایگان</td>
                            
                            </tr>

                            <tr class="Payable" v-if="discount.percent == 0">
                              <td colspan="2">
                                قابل پرداخت
                              </td>
                              <td colspan="4" >
                                {{Number((finalPrice/10)+((finalPrice/10)*0.10)).toLocaleString()}} تومان
                                <div>معادل به حروف</div>
                                {{((finalPrice/10)+((finalPrice/10)*0.10)).num2persian()}} تومان
                                <img class="mohr only_print " src="/img/mohr.png">
                              </td>
                            </tr>

                            <tr class="Payable discount" v-if="discount.percent != 0">
                              <td colspan="2">
                                تخفیف
                              </td>
                              <td colspan="5" >
                                {{Number((finalDiscount/10)).toLocaleString()}} تومان
                              </td>
                            </tr>

                            <tr class="Payable dis" v-if="discount.percent != 0">
                              <td colspan="2">
                                قابل پرداخت
                              </td>
                              <td colspan="5" >
                                {{Number(((finalPrice-finalDiscount)/10)+(((finalPrice-finalDiscount)/10)*0.10)).toLocaleString()}} تومان
                                <div>معادل به حروف</div>
                                {{(((finalPrice-finalDiscount)/10)+(((finalPrice-finalDiscount)/10)*0.10)).num2persian()}} تومان
                                <img class="mohr only_print " src="/img/mohr.png">
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <p class="only_print" style="font-size: 13px;margin-top: 10px;">
                          مدت اعتبار پیش فاکتور ۷۲ ساعت
                          <br>
                          شماره حساب  :  
                          1-2582417-40-810
                          بانک سامان (شرکت طرح و توسعه پردازش همکاران)
                          <br>
                          شماره شبا : 
                          IR860560081004002582417001
                          بانک سامان (شرکت طرح و توسعه پردازش همکاران)
                          <br>
                          شماره کارت : 
                          6219861035821650
                          بانک سامان (شرکت طرح و توسعه پردازش همکاران)
                        </p>
                        
                      </CCol>




                      <CCol md="12" class="no_print">
                        <div class="your_profit">
                          <h2>
                            <i class="fa-regular fa-lightbulb"></i>
                            آیا می‌دانستید؟
                          </h2>
                          <div>
                            فناوری تلفن ابری  نسبت به راهکارهای سنتی، قابلیت‌های بیشتر وعلاوه بر مقیاس‌پذیری بالاتر، صرفه اقتصادی قابل‌توجهی نیز دارد.
                            <br>
                            برای مثال درصورتی‌که بخواهید، مشابه
                            <b>{{plan[0].name}}({{plan[0].description}})</b>
                            را با استفاده از فناوری VOIP محلی پیاده‌سازی کنید، به‌طور متوسط هزینه زیر را متحمل خواهید شد.
                            <br><br>
                            <table class="invoice_t">
                              <tr>
                                <td style="width: 5px">ردیف</td>
                                <td style="width: 118px">عنوان</td>
                                <td style="width: 179px">مبلغ</td>
                                <td>شرح</td>
                              </tr>
                              <tr>
                                <td>
                                  1
                                </td>
                                <td>
                                  سرور و یا گتوی ویپ
                                </td>
                                <td>
                                  {{Number((Math.ceil(plan[0].base_price/100000)*100000)+profit.hardware_estimation).toLocaleString()}} تومان
                                </td>
                                <td>
                                  متوسط هزینه خرید سرور و یا گتوی VOIP مشابه با ظرفیت 
                                  {{plan[0].name}}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  2
                                </td>
                                <td>
                                  نصب و راه‌اندازی
                                </td>
                                <td>
                                  {{Number(profit.base_setup+(profit.config_price*plan[0].id)).toLocaleString()}} تومان
                                </td>
                                <td>
                                  متوسط هزینه نصب و راه‌اندازی ظرفیت مشابه 
                                  {{plan[0].name}} 
                                  تلفن ابری همکاران
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  3
                                </td>
                                <td>
                                  هزینه خرید خط مخابراتی 
                                </td>
                                <td>
                                  {{Number((totalLineNumber)).toLocaleString()}} تومان
                                </td>
                                <td>
                                  قیمت مصوب سازمان تنظیم مقرارات
                                  (مشابه هزینه فاکتور فوق است.)
                                </td>
                              </tr>
                            </table>
                            <br><br>
                            همین‌طور که مشاهده می‌کنید راه‌حل سنتی برای شما به‌طور متوسط 
                            <b>{{Number((voipEstimation)).toLocaleString()}} تومان</b>
                            هزینه خواهد داشت و علاوه بر آن معمولاً سالیانه نیز بین ۲۰ الی ۳۰ درصد هزینه نصب و راه‌اندازی معادل 
                            <b>{{Number((profit.base_setup+(profit.config_price*plan[0].id))*0.2).toLocaleString()}} تومان</b>
                            هزینه پشتیبانی و نگهداری خواهید داشت.

                            <br>
                            به عبارتی دیگر تخمین سود شما از استفاده از این فناوری جدید به شرح زیر است:
                          </div>
                          <div class="total_profit">
                            <table style="width: 100%;text-align: right;">
                              <tr style="color: #9a0000;"  v-if="discount.percent == 0">
                                <td>تخمین سود شما در استفاده از فناوری تلفن ابری : </td>
                                <td>{{Number(voipEstimation-(((finalPrice)/10)+(((finalPrice)/10)*0.10))).toLocaleString()}} تومان</td>
                              </tr>
                              <tr style="color: #9a0000;" v-if="discount.percent != 0">
                                <td>تخمین سود شما در استفاده از فناوری جدید تلفن ابری : </td>
                                <td>{{Number(voipEstimation-(((finalPrice-finalDiscount)/10)+(((finalPrice-finalDiscount)/10)*0.10))).toLocaleString()}} تومان</td>
                              </tr>
                              <tr style="font-size: 18px;font-weight: 100;color: #004900;"  v-if="discount.percent == 0">
                                <td style="padding-top: 20px;">مبلغ قابل پرداخت</td>
                                <td style="padding-top: 20px;">{{Number((finalPrice/10)+((finalPrice/10)*0.10)).toLocaleString()}} تومان</td>
                              </tr>
                              <tr style="font-size: 18px;font-weight: 100;color: #004900;" v-if="discount.percent != 0">
                                <td style="padding-top: 20px;">مبلغ قابل پرداخت</td>
                                <td style="padding-top: 20px;">{{Number(((finalPrice-finalDiscount)/10)+(((finalPrice-finalDiscount)/10)*0.10)).toLocaleString()}} تومان</td>
                              </tr>
                            </table>
                            
                            
                          </div>
                        </div>
                      </CCol>
                    </CRow>
                  </CCardBody>

                  <CCardFooter>
                    <CRow>
                      <CCol md="6" >
                        <CButton
                          @click="register.stage = 4;"
                          color="link"
                        >
                          برگشت و تغییر  شماره
                        </CButton>
                      </CCol>
                      <CCol md="6" style="text-align: left;">
                        
                        <CButton
                          @click="createPeyment()"
                          type="button"
                          class="reg_type_btn btn btn-info"
                        >
                          تایید و پرداخت
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCardFooter>
                      
                  <CElementCover v-if="loading" :opacity="0.5">
                    <CSpinner size="5xl" />
                  </CElementCover>
                </CCard>
              </CRow>
            </div>




          </div>
        </CCol>



        <CCol md="4" v-if="previewStages.indexOf(register.stage) >= 0 && register.plan > 0">
          <div class="invoice_preview">
            <h2>
              پیش نمایش صورتحساب
            </h2>
            <div :class="(discount.percent == 0)?'invoice_preview_warper':'invoice_preview_warper discount_pw'">
              <div class="annual_payments">
                <h3>اشتراک‌های سالیانه</h3>
                <div class="subscription_plan">
                  <div class="right">  
                    <div class="title">
                      {{plan[0].name}}
                    </div>
                    <div class="namad">
                      <img v-if="plan[0].id == 1" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-پایه-تلفن-ابری-همکاران-1-p8gvc7c8y092sd9g5df1dktfuf961bcgd8ysv9scc4.png.webp" title="طرح پایه تلفن ابری همکاران" alt="طرح پایه تلفن ابری همکاران">
                      <img v-if="plan[0].id == 2" style="height: 33px;" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-دو-تلفن-ابری-همکاران-p8gwa91shyuzbvt1c38joziigvfsumifprnyo3ayyc.png.webp" title="طرح دو تلفن ابری همکاران" alt="طرح دو تلفن ابری همکاران">
                      <img v-if="plan[0].id == 3" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-سه-تلفن-ابری-همکاران-p8gwsy28fcga8ong665fa9ojsralxwq8yarma7l378.png.webp" title="طرح سه تلفن ابری همکاران" alt="طرح سه تلفن ابری همکاران">
                      <img v-if="plan[0].id == 4" style="height: 33px;" src="https://hamkaran.cloud/wp-content/uploads/elementor/thumbs/-چهار-تلفن-ابری-همکاران-p8gwxr0jcv11kxo848ws121d3nm5a7suy2syl4gnec.png.webp" title="طرح چهار تلفن ابری همکاران" alt="طرح سه تلفن ابری همکاران">
                    </div>
                  </div>
                  <div class="left">
                    <div class="price" v-if="discount.percent == 0">
                      {{Number(plan[0].base_price/10).toLocaleString()}} تومان
                    </div>
                    <div class="price discount" v-if="discount.percent != 0">
                      {{Number(plan[0].base_price/10).toLocaleString()}} تومان
                    </div>
                    <div class="price" v-if="discount.percent != 0">
                      {{Number((plan[0].base_price-(plan[0].base_price*(discount.percent/100)))/10).toLocaleString()}} تومان
                    </div>
                    <div class="period">
                      اشتراک سالیانه
                      <span  style="display: block;">
                        {{plan[0].description}} 
                      </span>
                    </div>
                  </div>
                </div>

                <div class="subscription_plan" v-for="rplan in register.add_ons">
                  <div class="right">  
                    <div class="title">
                      {{rplan.name}}
                    </div>
                    <div class="namad">
                      <img v-if="rplan.id == 8" src="/img/webservice.png" style="height: 33px;">
                      <img v-if="rplan.id == 10" src="/img/webhookreg.png" style="height: 33px;">
                      <img v-if="rplan.id == 12" src="/img/call-center.png" style="height: 33px;">
                    </div>
                  </div>
                  <div class="left">
                    <div class="price" v-if="rplan.id == 12 && discount.percent == 0"  >
                      {{Number((rplan.base_price*rplan.vcount)/10).toLocaleString()}} تومان
                    </div>
                    <div class="price discount" v-if="rplan.id == 12 && discount.percent != 0">
                      {{Number((rplan.base_price*rplan.vcount)/10).toLocaleString()}} تومان
                    </div>
                    <div class="price" v-if="rplan.id == 12 && discount.percent != 0">
                      {{Number(((rplan.base_price*rplan.vcount)-(rplan.base_price*(discount.percent/100)))/10).toLocaleString()}} تومان
                    </div>



                    <div class="price" v-if="rplan.id != 12 && discount.percent == 0">
                      {{Number(rplan.base_price/10).toLocaleString()}} تومان
                    </div>
                    <div class="price discount" v-if="rplan.id != 12 && discount.percent != 0">
                      {{Number(rplan.base_price/10).toLocaleString()}} تومان
                    </div>
                    <div class="price" v-if="rplan.id != 12 && discount.percent != 0">
                      {{Number((rplan.base_price-(rplan.base_price*(discount.percent/100)))/10).toLocaleString()}} تومان
                    </div>
                    <div class="period">
                      اشتراک سالیانه
                      <span v-if="rplan.id == 12" style="display: block;">
                        {{rplan.vcount}} داخلی اضافی
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="one_payments">
                <h3>هزینه‌های یک‌بار پرداخت</h3>
                
                <div class="subscription_plan">
                  <div class="right">  
                    <div class="title">
                      {{setup.name}}
                    </div>
                    <div class="namad">
                      <img src="/img/setup.png" style="height: 33px;">
                    </div>
                  </div>
                  <div class="left">
                    <div class="price">
                      {{Number(setup.base_price/10).toLocaleString()}} تومان
                    </div>
                    <div class="period">
                      یکبار پرداخت
                    </div>
                  </div>
                </div>

                <div class="subscription_plan operator" v-for="number in register.numbers">
                  <div class="right">  
                    <div class="title">
                      {{operators.filter(i => i.id == number.oprator_id)[0].name.en}}
                    </div>
                    <div class="namad">
                      <img :src="'/img/'+operators.filter(i => i.id == number.oprator_id)[0].logo" style="height: 33px;">
                    </div>
                  </div>
                  <div class="left">
                    <div class="number">
                      <span>{{number.number.substring(0,3)}}</span>
                      <span>{{number.number.substring(3,7)}} {{number.number.substring(7,11)}}</span>
                    </div>
                    <div class="period">
                      {{number.dec}}
                    </div>
                    <div class="price" v-if="number.price == 0" style="padding-bottom: 2px;">
                      رایگان
                    </div>
                    <div class="price" v-if="number.price != 0" style="padding-bottom: 2px;">
                      {{Number(getNumberPrice(number.obj)/10+((number.obj.channel == 2)?'':number.obj.channel*(getChannelPrice(number.obj)/10))).toLocaleString()}} تومان
                    </div>
                  </div>
                </div>

              </div>

            </div>
            <div class="final_preview_peyment">
              <span>
                جمع کل قابل پرداخت
              </span>
              <span class="count" v-if="discount.percent == 0">
                {{Number(finalPrice/10).toLocaleString()}} تومان
              </span>
              <span class="count discount " v-if="discount.percent != 0">
                {{Number(finalPrice/10).toLocaleString()}} تومان
              </span>
              <span class="count " v-if="discount.percent != 0">
                {{Number((finalPrice-finalDiscount)/10).toLocaleString()}} تومان
              </span>
            </div>
          </div>
        </CCol>


      </CRow>

      <div style="text-align:center;padding: 20px;">
        <img src="/img/hamkaran-footer.png" alt="">
      </div>
    </CContainer>
    

    <ul class="circles">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
    </ul>
  </div>
</template>
<style>
.subscription_plan.list .type.oprator_2.num_1 {
    color: #000;
    font-weight: 100;
}

.subscription_plan.list .type.oprator_2.num_2 {
    color: #db0303;
}

.subscription_plan.list .type.oprator_2.num_3 {
    color: #00a9c0;
}

.subscription_plan.list .type.oprator_2.num_4 {
    color: #b39700;
}
span.timer {
    display: block;
    text-align: center;
    opacity: 0.6;
    margin: 9px 10px;
    font-size: 12px;
    margin-bottom: 13px;
}
</style>
<script>
import Num2persian from 'num2persian';
import printJS from 'print-js';

import { check } from 'yargs';

export default {
  name: "Register",
  data() {
    return {
      terms:[],
      payment:{
        step:1,
        token:"",
        status:0,
        go_to_bank:false,
      },
      provinces: {"1":{"text":"تهران","id":"1"},"2":{"text":"فارس","id":"2"},"3":{"text":"آذربایجان شرقی","id":"3"},"4":{"text":"گلستان","id":"4"},"5":{"text":"گیلان","id":"5"},"6":{"text":"کردستان","id":"6"},"7":{"text":"آذربایجان غربی","id":"7"},"8":{"text":"لرستان","id":"8"},"9":{"text":"البرز","id":"9"},"10":{"text":"اردبیل","id":"10"},"11":{"text":"مازندران","id":"11"},"12":{"text":"قم","id":"12"},"13":{"text":"سمنان","id":"13"},"14":{"text":"اصفهان","id":"14"},"15":{"text":"ایلام","id":"15"},"16":{"text":"خوزستان","id":"16"},"17":{"text":"بوشهر","id":"17"},"18":{"text":"هرمزگان","id":"18"},"19":{"text":"کرمان","id":"19"},"20":{"text":"کرمانشاه","id":"20"},"21":{"text":"سیستان و بلوچستان","id":"21"},"22":{"text":"قزوین","id":"22"},"23":{"text":"زنجان","id":"23"},"24":{"text":"خراسان رضوی","id":"24"},"25":{"text":"خراسان جنوبی","id":"25"},"26":{"text":"خراسان شمالی","id":"26"},"27":{"text":"یزد","id":"27"},"28":{"text":"چهارمحال و بختیاری","id":"28"},"29":{"text":"کهگیلویه و بویراحمد","id":"29"},"30":{"text":"مرکزی","id":"30"},"31":{"text":"همدان","id":"31"},"32":{"text":"- شماره ترابردپذیر کشوری -","id":"32"}},
      fileRecords: [],
      register: {
        discount:{
          discount_ceiling:0,
          percent:0,
          type:1
        },
        user: {
          type: "1", // 1=person, 2=legal
          status:"",
          mobile:"",
          person:{
            first_name:"",
            last_name:"",
            national_code:"",
            birth_certificate_number:"",
            father_name:"",
            mobile:"",
            email:"",
            phone:"",
            brand:"",
            address:"",
            postal_code:"",
            provinces:"",
            image_of_national_card:[],
            image_of_birth_certificate:[],
            position:"",
          },
          company:{
            last_changes:[],
            name:"",
            provinces:"",
            national_code:"",
            phone:"",
            email:"",
            site:"",
            stage:1,
            phone:"",
            address:"",
            company_national_code:"",
            postal_code:"",
            registered_advertisement:[],
            articles_of_association:[],
            registration_number:"",
          },
        },
        plan: 0,
        numbers: [], // value,channel_count
        add_ons: [],
        discouny_code:"",
        price: "",
        payment_status: "",
        stage:-1,
        loading:0,
      },
      verify_code: "", //50540
      verify_mobile: "",
      error: false,
      verify_step: 1,
      verify_timerCount: 0,
      form_errors: {
          person:{
            first_name:{
              name:"نام فارسی",
              status:false,
              message:"",
            },
            last_name:{
              name:"نام خانوادگی فارسی",
              status:false,
              message:"",
            },
            national_code:{
              name:"کد ملی",
              status:false,
              message:"",
            },
            birth_certificate_number:{
              name:"شماره شناسنامه",
              status:false,
              message:"",
            },
            father_name:{
              name:"نام پدر",
              status:false,
              message:"",
            },
            mobile:{
              name:"موبایل",
              status:false,
              message:"",
            },
            email:{
              name:"ایمیل",
              status:false,
              message:"",
            },
            phone:{
              name:"تلفن ثابت",
              status:false,
              message:"",
            },
            brand:{
              name:"نام کسب و کار",
              status:false,
              message:"",
            },
            address:{
              name:"آدرس",
              status:false,
              message:"",
            },
            postal_code:{
              name:"کد پستی",
              status:false,
              message:"",
            },
            image_of_national_card:{
              name:"تصویر کارت ملی",
              status:false,
              message:"",
            },
            image_of_birth_certificate:{
              name:"تصویر شناسنامه",
              status:false,
              message:"",
            },
            provinces:{
              name:"استان.",
              status:false,
              message:"",
            },
          },
          company:{
            name:{
              name:"نام شرکت",
              status:false,
              message:"",
            },
            articles_of_association:{
              name:"اساسنامه",
              status:false,
              message:"",
            },
            registered_advertisement:{
              name:"آگهی ثبتی",
              status:false,
              message:"",
            },
            company_national_code:{
              name:"شناسه ملی شرکت",
              status:false,
              message:"",
            },
            registration_number:{
              name:"شماره ثبت",
              status:false,
              message:"",
            },
            phone:{
              name:"تلفن ثابت",
              status:false,
              message:"",
            },
            email:{
              name:"ایمیل",
              status:false,
              message:"",
            },
            site:{
              name:"سایت",
              status:false,
              message:"",
            },
            provinces:{
              name:"استان",
              status:false,
              message:"",
            },
            postal_code:{
              name:"کد پستی",
              status:false,
              message:"",
            },
            address:{
              name:"آدرس",
              status:false,
              message:"",
            },
          },
          company_person:{
            first_name:{
              status:false,
            },
            last_name:{
              status:false,
            },
            national_code:{
              status:false,
            },
            mobile:{
              status:false,
            },
            email:{
              status:false,
            },
            image_of_birth_certificate:{
              status:false,
            },
            image_of_national_card:{
              status:false,
            }
          },
      },
      state: {
        formError: false,
        notSelectPlan: false,
        notNumberPlan: false,
        error: false,
        formLoading: false,
        errorotp: false,
        addOnError:false,
        successotp: false,
        sessionEnded: false,
        transferNumber: false,
        checkNum: false,
        discount_error: false,
        discount_status: "none",
      },
      animation: {
        legal: {
          autoplay: true,
          speed: 0.5,
          loop: true,
          width: "120px",
        },
        real: {
          autoplay: true,
          speed: 0.5,
          loop: true,
          width: "120px",
        },
        welcome: {
          autoplay: true,
          speed: 0.5,
          loop: true,
          width: "250px",
        },
        bank: {
          autoplay: true,
          speed: 0.5,
          loop: true,
          width: "150px",
        },
        done: {
          autoplay: true,
          speed: 0.5,
          width: "283px",
        },
        failed: {
          autoplay: true,
          speed: 0.5,
          width: "290px",
        }
      },
      errors: [],
      loading:false,
      uploadUrl: "https://api.hamkaran.cloud/api/v1/files-upload",
      uploadHeaders: {},
      fileRecordsForUpload: [],
      products:[],
      previewStages:[4,5,3],
      
      numbers:{
        channel:"2",
        channel_help:"<div style='width:300px;text-align: justify;'>طبق مصوبه سازمان تنظیم مقررات ارتباطات ،خطوط مخابراتی به صورت پیش فرض دارای دو تماس همزمان ورودی و یا خروجی هستند و در صورتی که کسی با خطوط معمولی تماس بگیرد برای نفر دوم بوق اشغال یا انتظار پخش می شود. اشخاص حقوقی این امکان را دارند که تعداد همزمانی تماس یا همان کانال رای برای هر شماره افزایش دهند. در این صورت در صورتی که نفر دوم و یا بیشتر به صورت همزمان با شماره شما تماس بگیرند خط آزاد است و می تواند به سناریوی تماس شما متصل شوند.</div>",
        oprator : {
          id:0,
        },
        type:'none',
        selected:'',
        prefix_id:'',
        province_id:'',
        prefixes:'',
        list:[],
      },
      discount:{
        discount_ceiling:0,
        percent:0,
        type:1,
      },
      meta:{},
      operators:[
        {
          id:1,
          name:{
            en:"Asiatech",
            fa:"آسیاتک"
          },
          prefix:"9130,9101",
          logo:"asiatech.png",
          active:1,
          provinces:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],
          help:"آسیاتک از سال 1396 سرویس تلفن ثابت خود را با سرشماره 9101 و 9130 در سراسر کشور واگذار می کند.",
        },
        {
          id:2,
          name:{
            en:"Pishagaman",
            fa:"پیشگامان"
          },
          provinces:[1,14,9,17,24,2,19,18,27],
          prefix:"9109",
          logo:"pishgaman.png",
          active:1,
          help:"پیشگامان از سال 1398 سرویس تلفن ثابت خود را با سرشماره 9109 در سراسر کشور واگذار می کند.",
        },
        {
          id:3,
          name:{
            en:"Shatel",
            fa:"شاتل"
          },
          prefix:"9100,9132",
          logo:"shatel.png",
          active:0,
          help:"شاتل از سال 1396 سرویس تلفن ثابت خود را با سرشماره 9100 و 9132 در سراسر کشور واگذار می کند.",
        },
        {
          id:4,
          name:{
            en:"TCI",
            fa:"مخابرات ایران"
          },
          prefix:"تمام پیش‌ شماره‌ها",
          logo:"tci.png",
          active:0,
          help:"شرکت مخابرات بعنوان اولین اپراتور تلفن در ایران از چند ده سال پیش در سراسر کشور سرویس ارائه می نماید.",
        },
        {
          id:5,
          name:{
            en:"Sabanet",
            fa:"صبانت"
          },
          prefix:"9102",
          logo:"sabanet.png",
          active:0,
          help:"صبانت از سال 1397 سرویس تلفن ثابت خود را با سرشماره 9102 در سراسر کشور واگذار می کند.",
        },
        {
          id:6,
          name:{
            en:"Fanap Telecom",
            fa:"فناپ تلکام"
          },
          prefix:"9103",
          logo:"fanaptelecom.png",
          active:0,
          help:"فناپ تلکام از سال 1396 سرویس تلفن ثابت خود را با سرشماره 9103 در سراسر کشور واگذار می کند.",
        },
        {
          id:7,
          name:{
            en:"Respina",
            fa:"رسپینا"
          },
          prefix:"9107",
          logo:"Respina.png",
          active:0,
          help:"رسپینا از سال 1397 سرویس تلفن ثابت خود را با سرشماره 9107 در سراسر کشور واگذار می کند.",
        },
        {
          id:8,
          name:{
            en:"Laser",
            fa:"لایزر"
          },
          prefix:"9131",
          logo:"laser.png",
          active:0,
          help:"لایزر از سال 1397 سرویس تلفن ثابت خود را با سرشماره 9131 در سراسر کشور واگذار می کند.",
        },
        {
          id:9,
          name:{
            en:"Mobinnet",
            fa:"مبین نت"
          },
          prefix:"0944",
          logo:"mobinnet.png",
          active:0,
          help:"مبین نت از سال 1398 سرویس تلفن خود را با سرشماره 0944 در سراسر کشور واگذار می کند.",
        }
      ],
      profit:{
        hardware_estimation:15000000,
        hardware_max:300000000,
        base_setup:50500000,
        config_price:3000000,
      }
    };
  },
  computed: {
    subscriptions() {
      return this.products.filter(i => i.type == 1);
    },
    plan() {
      return this.products.filter(i => i.id == this.register.plan);
    },
    asitech_channel_price() {
      return this.products.filter(i => i.id == 6)[0].base_price;
    },
    finalPrice() {
      var planPrice = this.plan[0].base_price;
      var setupPrice = this.setup.base_price;
      var fPrice=planPrice+setupPrice;
      let xx = this;
      this.register.add_ons.forEach(function(val, index, arr){
        if(xx.register.add_ons[index].id == 12){
          fPrice = fPrice+((xx.register.add_ons[index].base_price)*xx.register.add_ons[index].vcount);
        }else{
          fPrice = fPrice+xx.register.add_ons[index].base_price;
        }
      });
      this.register.numbers.forEach(function(val, index, arr){
        if(xx.register.numbers[index].type == 2){
          fPrice = fPrice+Number((xx.getNumberPrice(xx.register.numbers[index].obj)+((xx.register.numbers[index].obj.channel == 2)?'':xx.register.numbers[index].obj.channel*(xx.getChannelPrice(xx.register.numbers[index].obj)))));
        }
      });
      return fPrice;
    },
    voipEstimation(){
      let es = Number(Math.ceil(this.plan[0].base_price/100000)*100000)+this.profit.hardware_estimation;
      es = es+Number(this.profit.base_setup+(this.profit.config_price*this.plan[0].id));
      es = es+Number(this.totalLineNumber);
      return es;
    },
    finalDiscount() {
      var d_p=this.discount.percent/100;
      var planPrice = this.plan[0].base_price*d_p;
      var fDiscount=planPrice;
      let xx = this;
      this.register.add_ons.forEach(function(val, index, arr){
        if(xx.register.add_ons[index].id == 12){
          fDiscount = fDiscount+(((xx.register.add_ons[index].base_price)*xx.register.add_ons[index].vcount)*d_p);
        }else{
          fDiscount = fDiscount+(xx.register.add_ons[index].base_price*d_p);
        }
      });
      return fDiscount;
    },
    totalLineNumber() {
      var fPrice=0;
      let xx = this;
      this.register.numbers.forEach(function(val, index, arr){
        if(xx.register.numbers[index].type == 2){
          fPrice = fPrice+Number((xx.getNumberPrice(xx.register.numbers[index].obj)/10+((xx.register.numbers[index].obj.channel == 2)?'':xx.register.numbers[index].obj.channel*(xx.getChannelPrice(xx.register.numbers[index].obj)/10))));
        }
      });
      return fPrice;
    },
    setup() {
      return this.products.filter(i => i.id == 7)[0];
    },
    Addons() {
      return this.products.filter(i => i.type == 2).filter(i => i.active == 1).reverse();
    },
    formLoading() {
      return this.$store.state.formLoading;
    },
    formerror() {
      return this.$store.state.formerror;
    },
  },
  watch: {
    'register.user.person.provinces': {
      handler(value) {
        this.numbers.province_id = this.register.user.person.provinces;
        this.getprefixes();
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    'register.user.company.provinces': {
      handler(value) {
        this.numbers.province_id = this.register.user.company.provinces;
        this.getprefixes();
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    'numbers.oprator.id': {
      handler(value) {
        this.getprefixes();
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    'register.stage': {
      handler(value) {
        if(this.register.stage == 5){
          this.termsAndCondition();
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    verify_mobile: {
      handler(value) {
        this.register.user.mobile=this.verify_mobile;
        this.register.user.person.mobile=this.verify_mobile;
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    verify_timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(function () {
            this.verify_timerCount--;
            if(this.verify_timerCount == -1 )
              this.verify_timerCount = 0;

          }.bind(this), 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  }, 
  mounted() {
    this.state.formLoading = true;
    let url_query = (this.$route.query.c)?this.$route.query.c:'direct';
    let campaign = url_query;
    if(localStorage.getItem("c") != null ){
      campaign = (url_query == "direct")? localStorage.getItem("c"): url_query+','+localStorage.getItem("c");
    }

    if(localStorage.getItem("session") != null )
      this.checkSession();

    if(localStorage.getItem("session") === null )
      localStorage.setItem("session",Date.now());
    
    
    campaign = campaign.split(',').filter(function(item, pos,self) {return self.indexOf(item) == pos;});
    localStorage.setItem("c",campaign);
    this.verify_mobile = localStorage.getItem("verify_mobile");
    this.verify_code = localStorage.getItem("verify_code");
    

    if(typeof this.$route.query.token != 'undefined'){
      this.payment.token=this.$route.query.token;
      this.payment.status=this.$route.query.status;
    }
    console.log(this.$route.query.token);
    this.get_products();

    if(this.verify_code &&  this.verify_mobile && typeof this.$route.query.token === 'undefined' ){
      this.get_products();
      this.loading=true;
      var data = new FormData();
      data.append("mobile", this.verify_mobile);
      data.append("code", this.verify_code);
      axios.defaults.headers.common.Authorization = "";
      let x = this;
      axios
        .get("https://api.hamkaran.cloud/api/v1/registration", { params: { session_code: this.verify_code,session_mobile:this.verify_mobile } })
        .then(function(response) {
          x.loading = false;
          x.state.formLoading = false;
          if(response.data == "no_record"){
            x.register.user.mobile=x.verify_mobile;
            x.register.user.person.mobile=x.verify_mobile;
            x.register.stage=1;
          }else{
            x.register=response.data.data;
            x.meta=response.data;
            if(response.data.data.discouny_code)
              x.discount_check();

            if(x.meta.payment){
              if(x.meta.payment_status == 1){
                x.payment.step=3;
                x.payment.token=(x.meta.payment.token)?x.meta.payment.token:'-';
                x.payment.transId=(x.meta.payment.transaction_id)?x.meta.payment.transaction_id:'-';
                x.payment.status=1;
                x.payment.errorCode='';
                x.payment.errorMessage='';
              }else{
                x.payment.step=3;
                x.payment.status=0;
                x.payment.errorCode=(x.meta.payment.errorCode)?x.meta.payment.errorCode:'-';
                x.payment.errorMessage=(x.meta.payment.errorMessage)?x.meta.payment.errorMessage:'-';
              }
            }
          }
        })
        .catch(function(error) {
          x.register.stage=0;
          x.loading = false;
          x.state.formLoading = false;
          x.verify_code = "";
          x.verify_mobile = "";
          x.verify_step = 1;
        });
    }else if(this.$route.query.token){

      this.loading=true;
      var data = new FormData();
      data.append("mobile", this.verify_mobile);
      data.append("code", this.verify_code);
      axios.defaults.headers.common.Authorization = "";
      let x = this;
      axios
        .get("https://api.hamkaran.cloud/api/v1/registration/payment/verify", { params: { session_code: this.verify_code,session_mobile:this.verify_mobile, } })
        .then(function(response) {
          x.loading = false;
          x.state.formLoading = false;

          x.register=response.data.data;
          x.meta=response.data;
          if(x.meta.payment_status == 1){
            x.payment.step=3;
            x.payment.token=(x.meta.payment.token)?x.meta.payment.token:'-';
            x.payment.transId=(x.meta.payment.transaction_id)?x.meta.payment.transaction_id:'-';
            x.payment.status=1;
            x.payment.errorCode='';
            x.payment.errorMessage='';
          }else{
            x.payment.step=3;
            x.payment.status=0;
            x.payment.errorCode=(x.meta.payment.errorCode)?x.meta.payment.errorCode:'-';
            x.payment.errorMessage=(x.meta.payment.errorMessage)?x.meta.payment.errorMessage:'-';
          }
          

          if(response.data.data.discouny_code)
            x.discount_check();
        })
        .catch(function(error) {
          x.register.stage=0;
          x.loading = false;
          x.state.formLoading = false;
          x.verify_code = "";
          x.verify_mobile = "";
          x.verify_step = 1;
        });

    }else{
      this.register.stage=0;
      this.state.formLoading = false;
    }

    

  },  
  methods: {
    file_normalaze: function(name) {
      let xx = this;
      this.register.user.person.image_of_national_card.forEach(function(val, index, arr){
        xx.register.user.person.image_of_national_card[index]['urlResized'] = xx.register.user.person.image_of_national_card[index]['upload']['data']['urlResized'];
        xx.register.user.person.image_of_national_card[index]['name'] = xx.register.user.person.image_of_national_card[index]['upload']['data']['name'];
        xx.register.user.person.image_of_national_card[index]['url'] = xx.register.user.person.image_of_national_card[index]['upload']['data']['urlResized'];
      });

      this.register.user.person.image_of_birth_certificate.forEach(function(val, index, arr){
          xx.register.user.person.image_of_birth_certificate[index]['urlResized'] = xx.register.user.person.image_of_birth_certificate[index]['upload']['data']['urlResized'];
          xx.register.user.person.image_of_birth_certificate[index]['name'] = xx.register.user.person.image_of_birth_certificate[index]['upload']['data']['name'];
          xx.register.user.person.image_of_birth_certificate[index]['url'] = xx.register.user.person.image_of_birth_certificate[index]['upload']['data']['urlResized'];
      });

      this.register.user.company.registered_advertisement.forEach(function(val, index, arr){
          xx.register.user.company.registered_advertisement[index]['urlResized'] = xx.register.user.company.registered_advertisement[index]['upload']['data']['urlResized'];
          xx.register.user.company.registered_advertisement[index]['name'] = xx.register.user.company.registered_advertisement[index]['upload']['data']['name'];
          xx.register.user.company.registered_advertisement[index]['url'] = xx.register.user.company.registered_advertisement[index]['upload']['data']['urlResized'];
      });

      this.register.user.company.articles_of_association.forEach(function(val, index, arr){
          xx.register.user.company.articles_of_association[index]['urlResized'] = xx.register.user.company.articles_of_association[index]['upload']['data']['urlResized'];
          xx.register.user.company.articles_of_association[index]['name'] = xx.register.user.company.articles_of_association[index]['upload']['data']['name'];
          xx.register.user.company.articles_of_association[index]['url'] = xx.register.user.company.articles_of_association[index]['upload']['data']['urlResized'];
      });

      this.register.user.company.last_changes.forEach(function(val, index, arr){
          xx.register.user.company.last_changes[index]['urlResized'] = xx.register.user.company.last_changes[index]['upload']['data']['urlResized'];
          xx.register.user.company.last_changes[index]['name'] = xx.register.user.company.last_changes[index]['upload']['data']['name'];
          xx.register.user.company.last_changes[index]['url'] = xx.register.user.company.last_changes[index]['upload']['data']['urlResized'];
      });
    }, 
    fileDeleted: function(fileRecord) {
      console.log('fileDeleted');
    },
    onBeforeDelete: function(fileRecord,type) {
      console.log(fileRecord);
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
          this.$refs[type].deleteFileRecord(fileRecord); // will trigger 'delete' event
      }
    },
    filesSelected: function(fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
        validFileRecords
      );
    },
    scrollToBottom: function() {
      window.scrollTo(0, document.body.scrollHeight);
    },
    addToAddOn: function(addOn) {
      if(addOn.vadded==0){
        console.log('ommmmad injaaaaa');
        this.register.add_ons = this.register.add_ons.filter(i => i.id != addOn.id);
        this.state.addOnError=false;
        return true;
      }
      if(addOn.id==12 && addOn.vcount==0){
        this.register.add_ons = this.register.add_ons.filter(i => i.id != addOn.id);
        this.state.addOnError=true;
        return false;
      }
      if(addOn.id == 12 && addOn.vcount!=0)
        this.state.addOnError=false;
      
      this.register.add_ons = this.register.add_ons.filter(i => i.id != addOn.id);
      this.register.add_ons.push(addOn);
    },
    addonIsAdded: function(id) {
      if(!this.register.add_ons.filter(i => i.id == id)[0])
        return false;

      if(this.register.add_ons.filter(i => i.id == id)[0].vadded == 1)
        return true;
      
      return false;
      
    },
    getprefixes: function(loading=1) {
      this.numbers.prefix_id='';
      if(loading == 1)
        this.loading = true;
      if(!this.numbers.province_id)
       return false;

      // if(this.numbers.oprator.id != 1){
      //   this.numbers.prefixes = {1:"9109"};
        
      //   this.loading = false;
      //   return false;
      // }

       let x = this;
      axios.get('https://api.hamkaran.cloud/v1/automation/provincecodes/' +this.numbers.province_id+'/'+this.numbers.oprator.id).then(
        response => {
                this.numbers.prefixes = response.data;
                if(x.loading == true && x.register.stage != 5)
                  this.loading = false;
        })
    },
    getNumbers: function(prefixes_change) {
      
      this.state.checkNum=false;
      this.loading = true;
      if(prefixes_change)
        this.getprefixes(0);

        // v-if="operators[numbers.oprator.id-1].provinces.includes(parseInt(province.id))"
      axios.get('https://api.hamkaran.cloud/v1/automation/numbers/random/' +this.numbers.province_id +'/'+this.numbers.oprator.id).then(
        response => {
                this.numbers.list = response.data;
                this.loading = false;
        })
    },
    checkNumbers: function() {
      this.state.checkNum=false;
      let object = this.numbers.prefixes;
      let value = this.numbers.prefix_id;
      let prefix_index=Object.keys(object).find(key => object[key] === value);
      let province_id=this.numbers.province_id;
      let prefix_id =this.numbers.prefix_id;
      let numbersSelected=this.numbers.selected;
      if(!numbersSelected || !prefix_id || !province_id || !prefix_index || numbersSelected.length != 4 ){
        this.state.checkNum=true;
        this.numbers.list=[];
        return false;
      }
        
      
      this.loading = true;
      axios.get('https://api.hamkaran.cloud/v1/automation/number/'+prefix_id+'/'+numbersSelected).then(
        response => {
          this.numbers.list = response.data;
          this.loading = false;
        }).catch(error => {
          this.state.checkNum=true;
          this.numbers.list=[];
          this.loading = false;
        })
    },
    termsAndCondition: function() {
      this.terms='';
      this.loading = true;
      axios.get('https://hamkaran.cloud/wp-json/wp/v2/posts?include[]=5005').then(
        response => {
          this.terms= response.data[0];
          this.loading = false;
        })
    },
    addNumber: function(type,oprator_id,province_id,prefix_id,number,num_obj) {
      
      //type 1 = transfered  2 = new
      if(type == 1){
        if(province_id == '' || prefix_id == '' || number.length != 4 ||  !/^-?\d+$/.test(number) ) {

          this.state.transferNumber = true;
          let toast = {
            content: 'لطفا شماره مورد نظر خود جهت انتقال را وارد نمایید.',
            color:'danger'
          };
          this.$store.commit('addToast', toast);
          return false;
        }
        this.numbers.selected = '';
        const num = [];
        num['type']=type;
        num['oprator_id']=oprator_id;
        num['province_id']=province_id;
        num['prefix_id']=prefix_id;
        num['channel']=this.numbers.channel;
        num['number']=prefix_id+''+number;
        num['db_id']='';
        num['price_type']='free';
        num['price']=0;
        num['dec']='انتقال بستر';
        num['obj']={};
        this.register.numbers.push(Object.assign({}, num));
        this.state.transferNumber = false;
        this.state.notNumberPlan = false;
        let toast = {
          title: 'شماره درخواستی اضافه شد.',
          content: ' شماره  '+prefix_id+''+number+' با موفقعیت اضافه شد. ',
          color:'success'
        };
        this.$store.commit('addToast', toast);
        this.numbers.type = 'none';
      }
      //type 1 = transfered  2 = new
      if(type == 2){
        this.numbers.selected = '';
        const num = [];
        num['type']=type;
        num['oprator_id']=oprator_id;
        num['province_id']=province_id;
        num['prefix_id']=prefix_id;
        num['number']=number;
        num['db_id']=num_obj.id;
        num['price_type']='1';
        num['price']=this.getNumberPrice(num_obj);
        num_obj['channel']=this.numbers.channel;
        num['obj']=num_obj;        
        num['dec']=this.$t(`register.${oprator_id}.number_type.${num_obj.type}`)+' ('+num_obj.channel+' کاناله)';
        this.register.numbers.push(Object.assign({}, num));
        this.state.transferNumber = false;
        this.state.notNumberPlan = false;
        let toast = {
          title: 'شماره درخواستی اضافه شد.',
          content: ' شماره  '+number+' با موفقعیت اضافه شد. ',
          color:'success'
        };
        this.$store.commit('addToast', toast);
        this.numbers.type = 'none';
      }
    },
    getChannelPrice: function(number) {
      if (typeof number.provider === 'undefined') {
        number.provider = 'asiatech';
      }
      switch (number.provider) {
        case 'asiatech': //normal
          return this.products.filter(i => i.id == 6)[0].base_price;
          break;

        case 'pishgaman': // bronze
          return this.products.filter(i => i.id == 24)[0].base_price;
          break;
      
        default:
          return 0;
          break;
      }
    },
    getNumberPrice: function(number) {
      if (typeof number.provider === 'undefined') {
        number.provider = 'asiatech';
      }
      let type = number.provider+'_'+number.type;
      console.log(type);
      switch (type) {
        case 'asiatech_500': //normal
          return this.products.filter(i => i.id == 5)[0].base_price;
          break;

        case 'asiatech_4': // bronze
          return this.products.filter(i => i.id == 13)[0].base_price;
          break;

        case 'asiatech_2': //sliver
          return this.products.filter(i => i.id == 14)[0].base_price;
          break;

        case 'asiatech_1': //gold
          return this.products.filter(i => i.id == 15)[0].base_price;
          break; 

        case 'asiatech_5': //platinum
          return this.products.filter(i => i.id == 16)[0].base_price;
          break;

        case 'pishgaman_1': //platinum
          return this.products.filter(i => i.id == 19)[0].base_price;
          break;

        case 'pishgaman_2': //platinum
          return this.products.filter(i => i.id == 20)[0].base_price;
          break;

        case 'pishgaman_3': //platinum
          return this.products.filter(i => i.id == 21)[0].base_price;
          break;

        case 'pishgaman_4': //platinum
          return this.products.filter(i => i.id == 22)[0].base_price;
          break;

        case 'pishgaman_5': //platinum
          return this.products.filter(i => i.id == 23)[0].base_price;
          break;
      
        default:
          return 0;
          break;
      }
    },
    goToStage: function(stage) {

      if(stage == 2)
        this.register.stage = 2;

      if(stage < this.register.stage)
        this.register.stage=stage;

      return "";
    },
    stage_count: function(stage) {
      if(this.register.stage ==2 && stage == 1)
        return "select"; 

      if(stage == this.register.stage)
        return "select";

      if(stage < this.register.stage)
        return "done";

      return "";
    },
    form_check: function(type,cname) {
      switch(cname) {
      case 'image_of_birth_certificate':
        if (this.register.user[type].image_of_birth_certificate.length == 0) {
          this.form_errors[type].image_of_birth_certificate.status=true;
          this.form_errors[type].image_of_birth_certificate.message="تصویر شناسنامه را وارد کنید.";
        }else{
          this.form_errors[type].image_of_birth_certificate.status=false;
          this.form_errors[type].image_of_birth_certificate.message="";
        }
        break;
      case 'articles_of_association':
        if (this.register.user[type].articles_of_association.length == 0) {
          this.form_errors[type].articles_of_association.status=true;
          this.form_errors[type].articles_of_association.message="فایل یا تصویر اساسنامه را وارد کنید.";
        }else{
          this.form_errors[type].articles_of_association.status=false;
          this.form_errors[type].articles_of_association.message="";
        }
        break;
      case 'registered_advertisement':
        
        console.log(this.register.user[type].registered_advertisement);
        if (this.register.user[type].registered_advertisement.length == 0) {
          this.form_errors[type].registered_advertisement.status=false;
          this.form_errors[type].registered_advertisement.message="فایل یا تصویر آگهی ثبتی را وارد کنید.";
        }else{
          this.form_errors[type].registered_advertisement.status=false;
          this.form_errors[type].registered_advertisement.message="";
        }
        break;
      case 'image_of_national_card':
        if (this.register.user[[type]].image_of_national_card.length == 0) {
          this.form_errors[type].image_of_national_card.status=true;
          this.form_errors[type].image_of_national_card.message="تصویر کارت ملی را وارد کنید.";
        }else{
          this.form_errors[type].image_of_national_card.status=false;
          this.form_errors[type].image_of_national_card.message="";
        }
        break;
      case 'name':
        var str = this.register.user[type].name;
        var p = /^[\u0600-\u06FF\s]+$/;
        if (!p.test(str)) {
          this.form_errors[type].name.status=true;
          this.form_errors[type].name.message="لطفا نام را به صورت حروف فارسی وارد نمایید.";
        }else{
          this.form_errors[type].name.status=false;
          this.form_errors[type].name.message="";
        }
        break;
      case 'brand':
        var str = this.register.user[type].brand;
        var p = /^[\u0600-\u06FF\s]+$/;
        if (!p.test(str)) {
          this.form_errors[type].brand.status=true;
          this.form_errors[type].brand.message="لطفا نام کسب و کار را با حروف فارسی وارد نمایید.";
        }else{
          this.form_errors[type].brand.status=false;
          this.form_errors[type].brand.message="";
        }
        break;
      case 'first_name':
        var str = this.register.user[type].first_name;
        var p = /^[\u0600-\u06FF\s]+$/;
        if (!p.test(str)) {
          this.form_errors[type].first_name.status=true;
          this.form_errors[type].first_name.message="لطفا نام را به صورت حروف فارسی وارد نمایید.";
        }else{
          this.form_errors[type].first_name.status=false;
          this.form_errors[type].first_name.message="";
        }
        break;
      case 'last_name':
        var str = this.register.user[type].last_name;
        var p = /^[\u0600-\u06FF\s]+$/;
        if (!p.test(str)) {
          this.form_errors[type].last_name.status=true;
          this.form_errors[type].last_name.message="لطفا نام خانوادگی را به صورت حروف فارسی وارد نمایید.";
        }else{
          this.form_errors[type].last_name.status=false;
          this.form_errors[type].last_name.message="";
        }
        break;
      case 'phone':
        var str = this.register.user[type].phone;
        var p = /^0[0-9]{2,}[0-9]{8}$/;
        if (!p.test(str)) {
          this.form_errors[type].phone.status=true;
          this.form_errors[type].phone.message="شماره تلفن وارد شده صحیح نیست. (همراه با کد استان وارد شود).";
        }else{
          this.form_errors[type].phone.status=false;
          this.form_errors[type].phone.message="";
        }
        break;
      case 'registration_number':
        var str = this.register.user[type].registration_number;
        var p = /^[0-9]*$/;
        if (!p.test(str)) {
          this.form_errors[type].registration_number.status=true;
          this.form_errors[type].registration_number.message="شماره ثبت وارد شده معتبر نیست.";
        }else{
          this.form_errors[type].registration_number.status=false;
          this.form_errors[type].registration_number.message="";
        }
        break;
      case 'email':
        var str = this.register.user[type].email;
        var p = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!p.test(str)) {
          this.form_errors[type].email.status=true;
          this.form_errors[type].email.message="ایمیل وارد شده معتبر نیست.";
        }else{
          this.form_errors[type].email.status=false;
          this.form_errors[type].email.message="";
        }
        break;
      case 'address':
        var str = this.register.user[type].address;
        if (str === null || str === "") {
          this.form_errors[type].address.status=true;
          this.form_errors[type].address.message="ورود آدرس پستی اجباری است.";
        }else{
          this.form_errors[type].address.status=false;
          this.form_errors[type].address.message="";
        }
        break;
      case 'postal_code':
        var str = this.register.user[type].postal_code;
        var p = /\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/gm;
        if (!p.test(str)) {
          this.form_errors[type].postal_code.status=true;
          this.form_errors[type].postal_code.message="کد پستی وارد شده معتبر نیست.";
        }else{
          this.form_errors[type].postal_code.status=false;
          this.form_errors[type].postal_code.message="";
        }
        break;
      case 'provinces':
        var str = this.register.user[type].provinces;
        if (str === null || str === "") {
          this.form_errors[type].provinces.status=true;
          this.form_errors[type].provinces.message="استان خود را اتنتخاب کنید.";
        }else{
          this.form_errors[type].provinces.status=false;
          this.form_errors[type].provinces.message="";
        }
        break;
      case 'national_code':
        var meli_code = this.register.user[type].national_code;
        if (meli_code.length == 10) {
              if (meli_code == '1111111111' || meli_code == '0000000000' || meli_code == '2222222222' || meli_code == '3333333333' || meli_code == '4444444444' || meli_code == '5555555555' || meli_code == '6666666666' || meli_code == '7777777777' || meli_code == '8888888888' || meli_code == '9999999999') {
                    this.form_errors[type].national_code.status=true;
                    this.form_errors[type].national_code.message="کد ملی وارد شده صحیح نیست.";
              }else{
                var c = parseInt(meli_code.charAt(9));
                var n = parseInt(meli_code.charAt(0)) * 10 +
                parseInt(meli_code.charAt(1)) * 9 +
                parseInt(meli_code.charAt(2)) * 8 +
                parseInt(meli_code.charAt(3)) * 7 +
                parseInt(meli_code.charAt(4)) * 6 +
                parseInt(meli_code.charAt(5)) * 5 +
                parseInt(meli_code.charAt(6)) * 4 +
                parseInt(meli_code.charAt(7)) * 3 +
                parseInt(meli_code.charAt(8)) * 2;
                var r = n - parseInt(n / 11) * 11;

                if ((r == 0 && r == c) || (r == 1 && c == 1) || (r > 1 && c == 11 - r)) {
                      this.form_errors[type].national_code.status=false;
                      this.form_errors[type].national_code.message="";
                } else {
                      this.form_errors[type].national_code.status=true;
                      this.form_errors[type].national_code.message="کد ملی وارد شده صحیح نیست.";
                }

              }
        } else {
              this.form_errors[type].national_code.status=true;
              this.form_errors[type].national_code.message="کد ملی وارد شده کمتر از ۱۰ رقم می‌باشد.";
        }
        break;
      case 'company_national_code':
          var xv = this.register.user[type].company_national_code;
          if (isNaN(xv)) {
              this.form_errors[type].company_national_code.status=true;
              this.form_errors[type].company_national_code.message="لطفا شناسه ملی شرکت را وارد کنید.";
          } else if (xv == "") {
              this.form_errors[type].company_national_code.status=true;
              this.form_errors[type].company_national_code.message="لطفا شناسه ملی شرکت را وارد کنید.";
          } else if (xv.length < 11) {
              this.form_errors[type].company_national_code.status=true;
              this.form_errors[type].company_national_code.message="شناسه ملی شرکت وارد شده کمتر از ۱۱ رقم می‌باشد.";
          } else {
                this.form_errors[type].company_national_code.status=false;
                this.form_errors[type].company_national_code.message="";
          }
        break;
      default:
        // code block
    } 

    },
    sendotp: function() {
      this.state.error = false;
      if (!this.verify_mobile) {
        this.state.errorotp = true;
      } else {
        this.state.errorotp = false;
        this.state.formLoading = true;

        var data = new FormData();
        data.append("pbxcode", this.verify_mobile);
        data.append("mobile", this.verify_mobile);
        axios.defaults.headers.common.Authorization = "";
        let x = this;
        axios
          .post("https://api.hamkaran.cloud/v1/sendotp", data)
          .then(function(response) {
            x.state.formLoading = false;
            x.state.errorotp = false;
            x.state.successotp = true;
            x.verify_timerCount = 30;
          })
          .catch(function(error) {
            x.state.formLoading = false;
            x.state.errorotp = true;
          });
      }
    },
    verify: function() {
      
      localStorage.setItem("verify_code", this.verify_code);
      localStorage.setItem("verify_mobile", this.verify_mobile);
      this.state.error = false;
      if(this.state.formLoading)
        return true;
      if (!this.verify_mobile) {
        this.state.error = true;
      } else {
        this.state.error = false;
        this.state.formLoading = true;

        var data = new FormData();
        data.append("step", this.verify_step);
        data.append("mobile", this.verify_mobile);
        data.append("code", this.verify_code);
        localStorage.setItem("verify_code", this.verify_code);
        localStorage.setItem("verify_mobile", this.verify_mobile);

        axios.defaults.headers.common.Authorization = "";
        let x = this;
        axios
          .post("https://api.hamkaran.cloud/v1/register_verify", data)
          .then(function(response) {
            if (x.verify_step == 2) {
              if (response.data.status == "error") {
                x.state.formLoading = false;
                x.state.error = true;
                x.errors = response.data.error;
                return true;
              }
            }
            
            x.verify_timerCount = 60;
            x.state.error = false;
            
            x.verify_step = response.data.verify_step;
            // x.register.stage = response.data.stage;
            if(x.verify_step == 2){
              if(response.data.data === undefined || response.data.data == null || response.data.data.length <= 0){
                localStorage.setItem("session",Date.now());
                x.register.stage = response.data.stage;
                x.state.formLoading = false;
              }else{
                localStorage.setItem("session",Date.now());
                console.log(x.register);
                console.log(response);
                x.state.formLoading = true;
                x.register = response.data.data;
                x.meta=response.data.meta;
                if(response.data.data.discouny_code)
                  x.discount_check();
                if(x.meta.payment){
                  if(x.meta.payment_status == 1){
                    x.payment.step=3;
                    x.payment.token=(x.meta.payment.token)?x.meta.payment.token:'-';
                    x.payment.transId=(x.meta.payment.transaction_id)?x.meta.payment.transaction_id:'-';
                    x.payment.status=1;
                    x.payment.errorCode='';
                    x.payment.errorMessage='';
                  }else{
                    x.payment.step=3;
                    x.payment.status=0;
                    x.payment.errorCode=(x.meta.payment.errorCode)?x.meta.payment.errorCode:'-';
                    x.payment.errorMessage=(x.meta.payment.errorMessage)?x.meta.payment.errorMessage:'-';
                  }
                }
                x.state.formLoading = false;
              } 
            }

            
            
          })
          .catch(function(error) {
            x.state.formLoading = false;
            x.state.error = true;
          });
      }
    },
    onUpload(responses) {
      this.file_normalaze();
      let x = this;
      var NC=true;
      this.register.user.person.image_of_national_card.forEach(function(val, index, arr){
        if(x.register.user.person.image_of_national_card[index]['upload']['data'] == null)
          NC=false;
      });
      var BC=true;
      this.register.user.person.image_of_birth_certificate.forEach(function(val, index, arr){
        if(x.register.user.person.image_of_birth_certificate[index]['upload']['data'] == null)
          NC=false;
      });
      if(NC && BC)
        this.store_data();
    },
    store_data: function() {
      localStorage.setItem("session",Date.now());
      var data = new FormData();
      data.append("mobile", this.verify_mobile);
      data.append("session.code", this.verify_code);
      data.append("session.mobile", this.verify_mobile);
      data.append("c", localStorage.getItem("c"));

      data.append("data",JSON.stringify(this.register) );

      axios.defaults.headers.common.Authorization = "";
      let x = this;

      axios
        .post("https://api.hamkaran.cloud/api/v1/registration", data)
        .then(function(response) {
          x.loading = false;
          if(x.register.user.type == 2){
            if(x.register.user.company.stage != 2){
              x.register.user.company.stage++;
            }else{
              x.register.stage++;
            }
          }else{
            x.register.stage++;
          }
          
        })
        .catch(function(error) {
          console.log(error.response.data);
          x.register.stage = error.response.data.stage;
          x.state.formLoading = false;
          x.verify_code = "";
          x.verify_mobile = "";
          x.verify_step = error.response.data.verify_step;
          x.state.sessionEnded = error.response.data.error;
        });
    },
    save: function() {
      this.loading = true;
      let xx = this;
      this.state.formError=false;
      if(xx.register.stage == 2){
        if(xx.register.user.type == 1){
          Object.keys(this.form_errors.person).forEach(function(val, index, arr){
            xx.form_check("person",val);
            if(xx.form_errors.person[val].status){
              xx.state.formError=true;
            }
          });
        }else if(xx.register.user.type == 2 && xx.register.user.company.stage == 1){
          Object.keys(this.form_errors.company).forEach(function(val, index, arr){
            xx.form_check("company",val);
            if(xx.form_errors.company[val].status){
              xx.state.formError=true;
            }
          });
        }else if(xx.register.user.type == 2 && xx.register.user.company.stage == 2){
          Object.keys(this.form_errors.company_person).forEach(function(val, index, arr){
            xx.form_check("person",val);
            if(xx.form_errors.person[val].status){
              xx.state.formError=true;
            }
          });
        }
      }
      if(xx.register.stage == 3){
        if(xx.register.plan == 0){
          window.scrollTo(0,0);
          xx.state.notSelectPlan = true;
          this.loading = false;
          this.state.transferNumber = true;
          let toast = {
            content: 'برای ادامه باید طرح اشتراک خود را انتخاب نمایید.',
            color:'danger'
          };
          this.$store.commit('addToast', toast);
          return false;
        }
        xx.state.notSelectPlan = false;
      }
      if(xx.register.stage == 4){
        if(xx.register.numbers.length == 0){
          window.scrollTo(0,0);
          xx.state.notNumberPlan = true;
          this.loading = false;
          this.state.transferNumber = true;
          let toast = {
            content: 'جهت ادامه حداقال یک شماره تلفن انتخاب نمایید',
            color:'danger'
          };
          this.$store.commit('addToast', toast);
          return false;
        }
        xx.state.notNumberPlan = false;
      }
      if(this.state.formError){
        window.scrollTo(0,0);
        this.loading = false;
        return false;
      }
      if (this.fileRecordsForUpload.length != 0) {
          if(this.register.stage == 2 && this.register.user.type == 2 && this.register.user.company.stage == 1){
            this.$refs.RDvueFileAgent.upload(
              this.uploadUrl,
              this.uploadHeaders,
              this.fileRecordsForUpload
            );
            this.fileRecordsForUpload = [];
          }else if(this.register.stage == 2 && this.register.user.type == 2 && this.register.user.company.stage == 2){
            this.$refs.ICvueFileAgent.upload(
              this.uploadUrl,
              this.uploadHeaders,
              this.fileRecordsForUpload
            );
            this.fileRecordsForUpload = [];
          }else{
            this.$refs.NCvueFileAgent.upload(
              this.uploadUrl,
              this.uploadHeaders,
              this.fileRecordsForUpload
            );
            this.fileRecordsForUpload = [];
          }
      }else{
        this.file_normalaze();
        this.store_data();
      }

    },
    get_products: function() {
      var data = new FormData();
      data.append("mobile", this.verify_mobile);
      data.append("session.code", this.verify_code);
      data.append("session.mobile", this.verify_mobile);

      data.append("data",JSON.stringify(this.register) );

      axios.defaults.headers.common.Authorization = "";
      let x = this;
      
      axios
        .post("https://api.hamkaran.cloud/api/v1/products", data)
        .then(function(response) {
          x.products=response.data.data.data;
        })
        .catch(function(error) {
          console.log(error.response.data);
        });
    },
    discount_check: function() {

      var data = new FormData();
      data.append("code", this.register.discouny_code);
      data.append("mobile", this.verify_mobile);
      data.append("session.code", this.verify_code);
      data.append("session.mobile", this.verify_mobile);
      axios.defaults.headers.common.Authorization = "";
      this.loading=true;
      let x = this;
      axios
        .post("https://api.hamkaran.cloud/api/v1/discount/check", data)
        .then(function(response) {
          x.loading=false;
          x.state.discount_error = false;
          x.discount=response.data;
          x.register.discount=response.data;
          x.state.discount_status="valid";
        })
        .catch(function(error) {
          let toast = {
            title: 'کد وارد شده صحیح نیست',
            content: 'کد وارد شده اشتباه است و یا شرایط استفاده از آن به پایان رسیده.',
            color:'danger'
          };
          x.register.discount_ceiling=0;
          x.register.percent=0;
          x.register.type=0;
          x.$store.commit('addToast', toast);
          x.state.discount_error = true;
          x.loading=false;
        });
      
    },
    checkSession: function() {
      let session = localStorage.getItem("session");
      let now = Date.now();
      let expite_time = parseInt(session)+( 3 * 60 * 60 * 1000); //hour  min  sec  msec
      if (now > expite_time) {
        localStorage.removeItem('session');
        localStorage.removeItem('verify_mobile');
        localStorage.removeItem('verify_code');
      }
      
    },
    createPeyment: function() {
      localStorage.setItem("session",Date.now());
      var data = new FormData();
      data.append("mobile", this.verify_mobile);
      data.append("session.code", this.verify_code);
      data.append("session.mobile", this.verify_mobile);
      data.append("c", localStorage.getItem("c"));

      data.append("data",JSON.stringify(this.register) );

      axios.defaults.headers.common.Authorization = "";
      let x = this;
      x.payment.step=2;
      axios
        .post("https://api.hamkaran.cloud/api/v1/registration/payment/create", data)
        .then(function(response) {
          x.loading = false;
          x.payment = response.data;
          setTimeout(
            function() {
              window.location.href = x.payment.url;
            }, 1000);
        })
        .catch(function(error) {
          console.log(error.response.data);
          x.register.stage = error.response.data.stage;
          x.state.formLoading = false;
          x.verify_code = "";
          x.verify_mobile = "";
          x.verify_step = error.response.data.verify_step;
          x.state.sessionEnded = error.response.data.error;
        });
    },

  },
};
</script>
